import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import moment from "moment";
import api from "../actions/api";
import { hideLoader, showLoader } from "./loaderSlice";
import { showSnackBar } from "./snackSlice";

export const getBranchesDataSharing = createAsyncThunk(
  "getBranchesDataSharing",
  async (_, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).get(
        "/clinic/branch/data-sharing",
      );
      if (res?.status === 200) {
        thunkAPI.dispatch(hideLoader());
        return res?.data?.data ?? [];
      }
      thunkAPI.dispatch(hideLoader());
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
    }
  },
);

export const getBranchesDataSharingWoLoader = createAsyncThunk(
  "getBranchesDataSharingWoLoader",
  async (_, thunkAPI) => {
    try {
      // thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).get(
        "/clinic/branch/data-sharing",
      );
      if (res?.status === 200) {
        thunkAPI.dispatch(hideLoader());
        return res?.data?.data ?? [];
      }
      thunkAPI.dispatch(hideLoader());
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
    }
  },
);

export const createBranchDataSharing = createAsyncThunk(
  "createBranchDataSharing",
  async ({ data }, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).post(
        `/clinic/branch/data-sharing`,
        data,
      );
      if (res?.status === 200 || res?.status === 201) {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({
            message: "Settings updated successully!",
            type: "success",
          }),
        );
        return true;
      }
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Error encountered!",
          type: "error",
        }),
      );
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Error encountered!",
          type: "error",
        }),
      );
    }
  },
);

export const updateBranchDataSharing = createAsyncThunk(
  "updateBranchDataSharing",
  async ({ id, data }, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).put(
        `/clinic/branch/data-sharing/${id}`,
        data,
      );
      if (res?.status === 200 || res?.status === 201) {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({
            message: "Settings updated successully!",
            type: "success",
          }),
        );
        return true;
      }
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Error encountered!",
          type: "error",
        }),
      );
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Error encountered!",
          type: "error",
        }),
      );
    }
  },
);

export const getClinicBranches = createAsyncThunk(
  "getClinicBranches",
  async (_, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).get(
        "/clinic/branch",
      );
      if (res?.status === 200) {
        thunkAPI.dispatch(hideLoader());
        return res?.data?.data ?? [];
      }
      thunkAPI.dispatch(hideLoader());
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
    }
  },
);

export const getClinicBranchesWithClinicIdWoLoader = createAsyncThunk(
  "getClinicBranchesWithClinicIdWoLoader",
  async (url = "", thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).get(
        `/clinic/branch${url}`,
      );
      if (res?.status === 200) {
        thunkAPI.dispatch(hideLoader());
        return res?.data?.data ?? [];
      }
      thunkAPI.dispatch(hideLoader());
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
    }
  },
);

export const getMainClinicDetailsWoLoader = createAsyncThunk(
  "getMainClinicDetailsWoLoader",
  async (id, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).get(
        `/clinic/doctor/${id}`,
      );
      if (res?.status === 200) {
        thunkAPI.dispatch(hideLoader());
        return res?.data?.data ?? [];
      }
      thunkAPI.dispatch(hideLoader());
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
    }
  },
);

export const createUpdateClinicBranch = createAsyncThunk(
  "createUpdateClinicBranch",
  async ({ data, successMsg = "Branch created successfully" }, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).post(
        `/clinic/branch`,
        data,
      );
      if (res?.status === 200 || res?.status === 201) {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({ message: successMsg, type: "success" }),
        );
        return true;
      }
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Error encountered!",
          type: "error",
        }),
      );
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Error encountered!",
          type: "error",
        }),
      );
    }
  },
);

export const updateClinicBranchStatus = createAsyncThunk(
  "updateClinicBranchStatus",
  async ({ id, status = "N" }, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).put(
        `/clinic/branch?userId=${id}&active=${status}`,
      );
      if (res?.status === 200 || res?.status === 201) {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({
            message: "Status updated successfully!",
            type: "success",
          }),
        );
        return true;
      }
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Error encountered!",
          type: "error",
        }),
      );
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Error encountered!",
          type: "error",
        }),
      );
    }
  },
);

export const getVitalGroupsWoLoader = createAsyncThunk(
  "getVitalGroupsWoLoader",
  async (url = "", thunkAPI) => {
    try {
      // thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).get(
        `/getall/clinic/groupNames${url}`,
      );
      if (res?.status === 200) {
        // thunkAPI.dispatch(hideLoader());
        return res?.data?.data ?? [];
      }
      // thunkAPI.dispatch(hideLoader());
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
    }
  },
);

export const getCoreVitalsWoLoader = createAsyncThunk(
  "getCoreVitalsWoLoader",
  async (url = "", thunkAPI) => {
    try {
      // thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).get(
        `/getall/clinic/core-vitals`,
      );
      if (res?.status === 200) {
        // thunkAPI.dispatch(hideLoader());
        return res?.data?.data ?? [];
      }
      // thunkAPI.dispatch(hideLoader());
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
    }
  },
);

export const getVitalGroupsDetailsByIdWoLoader = createAsyncThunk(
  "getVitalGroupsDetailsByIdWoLoader",
  async (groupId, thunkAPI) => {
    try {
      // thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).get(
        `/getall/clinic/group/${groupId}/vitals`,
      );
      if (res?.status === 200) {
        // thunkAPI.dispatch(hideLoader());
        return res?.data?.data ?? [];
      }
      // thunkAPI.dispatch(hideLoader());
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
    }
  },
);

export const getClinicFacilities = createAsyncThunk(
  "getClinicFacilities",
  async (url = "", thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).get(
        `/getall/clinic/facilities${url}`,
      );
      if (res?.status === 200) {
        thunkAPI.dispatch(hideLoader());
        return res?.data?.data;
      }
      thunkAPI.dispatch(hideLoader());
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
    }
  },
);

export const getClinicFacilitiesWoLoader = createAsyncThunk(
  "getClinicFacilitiesWoLoader",
  async (_, thunkAPI) => {
    try {
      // thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).get(
        "/getall/clinic/facilities",
      );
      if (res?.status === 200) {
        // thunkAPI.dispatch(hideLoader());
        return res?.data?.data;
      }
      thunkAPI.dispatch(hideLoader());
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
    }
  },
);

export const createFacility = createAsyncThunk(
  "createFacility",
  async (data, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).post(
        `/create/clinic/facilites`,
        data,
      );
      if (res.status === 200 || res.status === 201) {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({
            message: "Facility created successfully",
            type: "success",
          }),
        );
        return res?.data?.data;
      }
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Failed to create facility",
          type: "error",
        }),
      );
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Failed to create facility",
          type: "error",
        }),
      );
    }
  },
);

export const updateFacilityById = createAsyncThunk(
  "updateFacilityById",
  async ({ facilityId, data }, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).put(
        `/update/clinic/facilites/${facilityId}`,
        data,
      );
      if (res?.status === 200 || res?.status === 201) {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({
            message: "Facility updated successfully",
            type: "success",
          }),
        );
        return true;
      }
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Facility update failed!",
          type: "error",
        }),
      );
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Facility update failed!",
          type: "error",
        }),
      );
    }
  },
);

export const deleteFacilityById = createAsyncThunk(
  "deleteFacilityById",
  async (facilityId, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).delete(
        `/delete/clinic/facilites/${facilityId}`,
      );
      if (res?.status === 200 || res?.status === 201) {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({
            message: "Facility deleted successfully",
            type: "success",
          }),
        );
        return true;
      }
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Facility delete failed!",
          type: "error",
        }),
      );
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Facility delete failed!",
          type: "error",
        }),
      );
    }
  },
);

export const getUserDetailsById = createAsyncThunk(
  "getUserDetailsById",
  async (userId, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).get(
        `/user?userId=${userId}`,
      );
      if (res?.status === 200) {
        thunkAPI.dispatch(hideLoader());
        return res?.data?.data;
      }
      thunkAPI.dispatch(hideLoader());
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
    }
  },
);

export const getClinicAppointemnts = createAsyncThunk(
  "getClinicAppointemnts",
  async (url = "", thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).get(
        `/clinic/appointments`,
      );
      if (res?.status === 200) {
        thunkAPI.dispatch(hideLoader());
        return res?.data?.data;
      }
      thunkAPI.dispatch(hideLoader());
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
    }
  },
);

export const getClinicAppointemntList = createAsyncThunk(
  "getClinicAppointemntList",
  async (url = "", thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).get(
        `/appointments/clinic/doctors${url}`,
      );
      if (res?.status === 200) {
        thunkAPI.dispatch(hideLoader());
        return res.data.data;
      }
      thunkAPI.dispatch(hideLoader());
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
    }
  },
);

export const getClinicAppointemntListWithoutLoading = createAsyncThunk(
  "getClinicAppointemntListWithoutLoading",
  async (url = "", thunkAPI) => {
    try {
      // thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).get(
        `/appointments/clinic/doctors${url}`,
      );
      if (res?.status === 200) {
        // thunkAPI.dispatch(hideLoader());
        return res?.data?.data;
      }
      // thunkAPI.dispatch(hideLoader());
    } catch (err) {
      // thunkAPI.dispatch(hideLoader());
    }
  },
);

export const getClinicStockSales = createAsyncThunk(
  "getClinicStockSales",
  async (url = "", thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).get(
        `/stock/sales`,
      );
      if (res?.status === 200) {
        thunkAPI.dispatch(hideLoader());
        return res?.data?.data;
      }
      thunkAPI.dispatch(hideLoader());
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
    }
  },
);

export const updateAppointmentStatusById = createAsyncThunk(
  "updateAppointmentStatusById",
  async ({ appointmentId, status, successMsg = null, url = "" }, thunkAPI) => {
    const profile = JSON.parse(localStorage.getItem("user"));
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).put(
        `/appointments/${appointmentId}/doctor?status=${status}${url}`,
      );
      if (res?.status === 200 || res?.status === 201) {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({
            message: successMsg
              ? successMsg
              : status === "scheduled"
                ? "Appointment scheduled successfully!"
                : "Appointment has been declined!",
            type: "success",
          }),
        );
        return true;
      }
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Error encountered!",
          type: "error",
        }),
      );
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      if (
        err?.response?.data?.status === 500 &&
        err?.response?.data?.message ===
          "Exactly one of token, topic or condition must be specified"
      ) {
        thunkAPI.dispatch(
          showSnackBar({
            message:
              status === "scheduled"
                ? "Appointment scheduled successfully!"
                : "Appointment has been declined!",
            type: "success",
          }),
        );
      } else {
        thunkAPI.dispatch(
          showSnackBar({
            message: "Error encountered!",
            type: "error",
          }),
        );
      }
    }
  },
);

export const updateCaseSummaryUrlByApntId = createAsyncThunk(
  "updateCaseSummaryUrlByApntId",
  async ({ apntId, form }, thunkAPI) => {
    try {
      // thunkAPI.dispatch(showLoader());
      const res = await api({
        contentType: true,
        auth: true,
        formData: true,
      }).put(`/appointment/${apntId}/casesummary`, form);
      if (res?.status === 200 || res?.status === 201) {
        // thunkAPI.dispatch(hideLoader());
        // thunkAPI.dispatch(
        //   showSnackBar({
        //     message: successMsg
        //       ? successMsg
        //       : status === "scheduled"
        //       ? "Appointment scheduled successfully!"
        //       : "Appointment has been declined!",
        //     type: "success",
        //   })
        // );
        return true;
      }
      // thunkAPI.dispatch(hideLoader());
      // thunkAPI.dispatch(
      //   showSnackBar({
      //     message: "Error encountered!",
      //     type: "error",
      //   })
      // );
    } catch (err) {
      // thunkAPI.dispatch(hideLoader());
    }
  },
);

export const getInpatientTasks = createAsyncThunk(
  "getInpatientTasks",
  async (_, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).get(
        "/getAll/tasks",
      );
      if (res?.status === 200) {
        thunkAPI.dispatch(hideLoader());
        return res.data.data;
      }
      thunkAPI.dispatch(hideLoader());
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
    }
  },
);

export const getBillDetailsByPaymentId = createAsyncThunk(
  "getBillDetailsByPaymentId",
  async (paymentId, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).get(
        `/appointment/clinic/payments/${paymentId}`,
      );
      if (res?.status === 200) {
        thunkAPI.dispatch(hideLoader());
        return res.data.data;
      }
      thunkAPI.dispatch(hideLoader());
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
    }
  },
);

export const getBillDetailsByPaymentIdWoLoader = createAsyncThunk(
  "getBillDetailsByPaymentIdWoLoader",
  async (paymentId, thunkAPI) => {
    try {
      // thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).get(
        `/appointment/clinic/payments/${paymentId}`,
      );
      if (res?.status === 200) {
        thunkAPI.dispatch(hideLoader());
        return res.data.data;
      }
      thunkAPI.dispatch(hideLoader());
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
    }
  },
);

export const updateBillCheckDetails = createAsyncThunk(
  "updateBillCheckDetails",
  async (
    { paymentId = null, showSublineItems = true, showSublinePrice = true },
    thunkAPI,
  ) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).put(
        `/clinic/payments/${paymentId}/showSubline?showSublineItems=${showSublineItems}&showSublinePrice=${showSublinePrice}`,
      );
      if (res?.status === 200 || res?.status === 201) {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({
            message: "Status updated successfully",
            type: "success",
          }),
        );
        return true;
      }
      thunkAPI.dispatch(hideLoader());
      return false;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
    }
  },
);

export const postClinicalNotes = createAsyncThunk(
  "postClinicalNotes",
  async (data, thunkAPI) => {
    try {
      thunkAPI.dispatch(
        setApiInProgress({ apiType: "clinicNotesPost", inProgress: true }),
      );
      thunkAPI.dispatch(showLoader());
      const res = await api({
        contentType: true,
        auth: true,
        // formData: true,
      }).post(`/appointment/${data?.appId}/notes`, data?.data);
      thunkAPI.dispatch(
        setApiInProgress({ apiType: "clinicNotesPost", inProgress: false }),
      );
      if (res?.status === 200) {
        thunkAPI.dispatch(hideLoader());
        return res.data.data;
      }
      thunkAPI.dispatch(hideLoader());
    } catch (err) {
      thunkAPI.dispatch(
        setApiInProgress({ apiType: "clinicNotesPost", inProgress: false }),
      );
      thunkAPI.dispatch(hideLoader());
    }
  },
);

export const postClinicalNotesWoLoader = createAsyncThunk(
  "postClinicalNotesWoLoader",
  async ({ appId, form }, thunkAPI) => {
    try {
      thunkAPI.dispatch(
        setApiInProgress({ apiType: "clinicNotesPost", inProgress: true }),
      );
      // thunkAPI.dispatch(showLoader());
      const res = await api({
        contentType: true,
        auth: true,
        formData: true,
      }).post(`/appointment/${appId}/clinic/notes`, form);
      thunkAPI.dispatch(
        setApiInProgress({ apiType: "clinicNotesPost", inProgress: false }),
      );
      if (res?.status === 200) {
        // thunkAPI.dispatch(hideLoader());
        return res.data.data;
      }
      // thunkAPI.dispatch(hideLoader());
    } catch (err) {
      thunkAPI.dispatch(
        setApiInProgress({ apiType: "clinicNotesPost", inProgress: false }),
      );
      // thunkAPI.dispatch(hideLoader());
    }
  },
);

export const enableCheckoutByAppointmentId = createAsyncThunk(
  "enableCheckoutByAppointmentId",
  async ({ apntId, paymentId, url = "" }, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).put(
        `/appointment/${apntId}/payment/${paymentId}/checkout${url}`,
        // `/appointment/${apntId}/checkout?checkout=true`
      );
      if (res?.status === 200 || res?.status === 201) {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({
            message: "Bill status updated successfully",
            type: "success",
          }),
        );
        return true;
      }
      thunkAPI.dispatch(hideLoader());
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
    }
  },
);

export const checkoutDirectBilling = createAsyncThunk(
  "checkoutDirectBilling",
  async ({ paymentId, url = "" }, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).put(
        `/appointment/payment/${paymentId}/checkout${url}`,
      );
      if (res?.status === 200 || res?.status === 201) {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({
            message: "Bill status updated successfully",
            type: "success",
          }),
        );
        return true;
      }
      thunkAPI.dispatch(hideLoader());
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
    }
  },
);

export const updateClinicalNote = createAsyncThunk(
  "updateClinicalNote",
  async (data, thunkAPI) => {
    try {
      thunkAPI.dispatch(
        setApiInProgress({ apiType: "clinicNotesPut", inProgress: true }),
      );
      thunkAPI.dispatch(showLoader());
      const res = await api({
        contentType: true,
        auth: true,
        formData: true,
      }).put(`/clinic/notes/${data?.noteId}`, data?.form);
      thunkAPI.dispatch(
        setApiInProgress({ apiType: "clinicNotesPut", inProgress: false }),
      );
      if (res?.status === 200) {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({
            message: "Note updated successfully",
            type: "success",
          }),
        );
        return true;
      }
      thunkAPI.dispatch(hideLoader());
    } catch (err) {
      thunkAPI.dispatch(
        setApiInProgress({ apiType: "clinicNotesPut", inProgress: false }),
      );
      thunkAPI.dispatch(hideLoader());
    }
  },
);

export const updateClinicalNoteWoLoader = createAsyncThunk(
  "updateClinicalNoteWoLoader",
  async (data, thunkAPI) => {
    try {
      thunkAPI.dispatch(
        setApiInProgress({ apiType: "clinicNotesPut", inProgress: true }),
      );
      // thunkAPI.dispatch(showLoader());
      const res = await api({
        contentType: true,
        auth: true,
        formData: true,
      }).put(`/clinic/notes/${data?.noteId}`, data?.form);
      thunkAPI.dispatch(
        setApiInProgress({ apiType: "clinicNotesPut", inProgress: false }),
      );
      if (res?.status === 200 || res?.status === 201) {
        // thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({
            message: "Note updated successfully",
            type: "success",
          }),
        );
        return res?.data?.data;
      }

      // thunkAPI.dispatch(hideLoader());
    } catch (err) {
      thunkAPI.dispatch(
        setApiInProgress({ apiType: "clinicNotesPut", inProgress: false }),
      );
      // thunkAPI.dispatch(hideLoader());
    }
  },
);

export const deleteClinicalNoteById = createAsyncThunk(
  "deleteClinicalNoteById",
  async ({ id, type = "outpatient" }, thunkAPI) => {
    try {
      // thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).delete(
        `/clinic/notes/${id}${type ? `?type=${type}` : ""}`,
      );
      if (res?.status === 200 || res?.status === 201) {
        // thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({
            message: "Record discarded successfully",
            type: "success",
          }),
        );
        return true;
      }
      // thunkAPI.dispatch(hideLoader());
    } catch (err) {
      // thunkAPI.dispatch(hideLoader());
    }
  },
);

export const addBillingItemsByPaymentId = createAsyncThunk(
  "addBillingItemsByPaymentId",
  async (data, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).post(
        `/appointment/clinic/payments/${data?.paymentId}`,
        data?.data,
      );
      if (res?.status === 200) {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({
            message: "Payment Item added successfully",
            type: "success",
          }),
        );
        return true;
      }
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Error encountered!",
          type: "error",
        }),
      );
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Error encountered!",
          type: "error",
        }),
      );
    }
  },
);

export const addDirectBilling = createAsyncThunk(
  "addDirectBilling",
  async (data, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).post(
        `/direct/clinic/payments`,
        data,
      );
      if (res?.status === 200) {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({
            message: "Billing added successfully",
            type: "success",
          }),
        );
        return res?.data;
      }
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Error encountered!",
          type: "error",
        }),
      );
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Error encountered!",
          type: "error",
        }),
      );
    }
  },
);

export const updateDirectBilling = createAsyncThunk(
  "updateDirectBilling",
  async (data, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).put(
        `/direct/clinic/payments/${data?.paymentId}`,
        data?.data,
      );
      if (res?.status === 200) {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({
            message: "Billing updated successfully",
            type: "success",
          }),
        );
        return res?.data;
      }
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Error encountered!",
          type: "error",
        }),
      );
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Error encountered!",
          type: "error",
        }),
      );
    }
  },
);

export const checkedInApi = createAsyncThunk(
  "checkedInApi",
  async (data, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).post(
        `/appointment/${data?.appointmentId}/user/checkin`,
      );
      if (res?.status === 200) {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({
            message: "Status updated successfully!",
            type: "success",
          }),
        );
        return true;
      }
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Error encountered!",
          type: "error",
        }),
      );
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Error encountered!",
          type: "error",
        }),
      );
    }
  },
);

export const checkedCallInApi = createAsyncThunk(
  "checkedCallInApi",
  async (data, thunkAPI) => {
    const profile = JSON.parse(localStorage.getItem("user"));
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).post(
        `/appointment/${data?.appointmentId}/doctor/${data?.doctorId}/checkin/${data?.facilityId}/facility/${data?.facilityName}`,
      );
      if (res?.status === 200 || res?.status === 201) {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({
            message: "Patient has been notified!",
            type: "success",
          }),
        );
        return true;
      }
      thunkAPI.dispatch(hideLoader());
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
    }
  },
);

export const updateBillingByPaymentId = createAsyncThunk(
  "updateBillingByPaymentId",
  async (data, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).put(
        `/appointment/payments/${data?.paymentId}`,
        data?.data,
      );

      if (res?.status === 200) {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({
            message: "Payment updated successfully",
            type: "success",
          }),
        );
        return true;
      }
      thunkAPI.dispatch(hideLoader());
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
    }
  },
);

export const updateCheckedIn = createAsyncThunk(
  "updateCheckedIn",
  async (appId, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).put(
        `appointments/${appId}/doctor?status=inprogress`,
      );

      if (res?.status === 200) {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({
            message: "Check-in updated successfully",
            type: "success",
          }),
        );
        return true;
      }
      thunkAPI.dispatch(hideLoader());
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
    }
  },
);

export const updateCancel = createAsyncThunk(
  "updateCancel",
  async (payload, thunkAPI) => {
    const profile = JSON.parse(localStorage.getItem("user"));
    const appId = typeof payload === "object" ? payload.appId : payload;
    const reason = typeof payload === "object" ? payload.reason : "";
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).put(
        `/appointments/${appId}/doctor?status=cancelled&reason=${reason}`,
      );
      if (res?.status === 200 || res?.status === 201) {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({
            message: reason
              ? `Appointment cancelled successfully. Reason: ${reason}`
              : "Appointment cancelled successfully",
            type: "success",
          }),
        );
        return true;
      }
      thunkAPI.dispatch(hideLoader());
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
    }
  },
);

export const updateCompleted = createAsyncThunk(
  "updateCompleted",
  async (appId, thunkAPI) => {
    const profile = JSON.parse(localStorage.getItem("user"));
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).put(
        `/appointments/${appId}/doctor?status=completed`,
      );
      if (res?.status === 200 || res?.status === 201) {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({
            message: "Status updated successfully",
            type: "success",
          }),
        );
        return true;
      }
      thunkAPI.dispatch(hideLoader());
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
    }
  },
);

export const updateFinalize = createAsyncThunk(
  "updateFinalize",
  async (appId, thunkAPI) => {
    const profile = JSON.parse(localStorage.getItem("user"));
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).put(
        `/appointments/${appId}/doctor?status=finalize`,
      );
      if (res?.status === 200 || res?.status === 201) {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({
            message: "Status updated successfully!",
            type: "success",
          }),
        );
        return true;
      }
      thunkAPI.dispatch(hideLoader());
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({ message: "Error encountered!", type: "error" }),
      );
    }
  },
);

export const updateConsult = createAsyncThunk(
  "updateConsult",
  async (appId, thunkAPI) => {
    const profile = JSON.parse(localStorage.getItem("user"));
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).put(
        `/appointments/${appId}/doctor?status=consultation`,
      );
      if (res?.status === 200 || res?.status === 201) {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({
            message: "Appointment updated successfully",
            type: "success",
          }),
        );
        return true;
      }
      thunkAPI.dispatch(hideLoader());
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
    }
  },
);

export const updatePayment = createAsyncThunk(
  "updatePayment",
  async (data, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).put(
        `/appointment/clinic/final/payments/
${data?.paymentId}?paymentMode=${data?.paymentMode}&amount=${data?.paymentAmount}`,
        // data?.data
      );

      if (res?.status === 200 || res?.status === 201) {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({
            message: "Payment updated successfully!",
            type: "success",
          }),
        );
        return true;
      }
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Error encountered!",
          type: "error",
        }),
      );
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Error encountered!",
          type: "error",
        }),
      );
    }
  },
);

export const updateMultiplePayment = createAsyncThunk(
  "updateMultiplePayment",
  async (data, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).put(
        `/appointment/clinic/final/multiple/payments`,
        data,
      );
      if (res?.status === 200 || res?.status === 201) {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({
            message: "Payment updated successfully!",
            type: "success",
          }),
        );
        return true;
      }
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Error encountered!",
          type: "error",
        }),
      );
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Error encountered!",
          type: "error",
        }),
      );
    }
  },
);

export const clinicRescheduleAppointment = createAsyncThunk(
  "clinicRescheduleAppointment",
  async (data, thunkAPI) => {
    const profile = JSON.parse(localStorage.getItem("user"));
    try {
      // thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).put(
        `/clinic/book/appointment/${data?.appointmentId}`,
        data?.data,
      );
      if (res?.status === 200 || res?.status === 201) {
        // thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({
            message: "Appointment updated successfully!",
            type: "success",
          }),
        );
        return true;
      }
      // thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Appointment update failed",
          type: "error",
        }),
      );
    } catch (err) {
      // thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Appointment update failed",
          type: "error",
        }),
      );
    }
  },
);

export const clinicReassignAppointmentById = createAsyncThunk(
  "clinicReassignAppointmentById",
  async (data, thunkAPI) => {
    try {
      // thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).put(
        `/clinic/update/book/appointment/${data?.appointmentId}`,
        data?.data,
      );
      if (res?.status === 200 || res?.status === 201) {
        // thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({
            message: "Appointment updated successfully!",
            type: "success",
          }),
        );
        return true;
      }
      // thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Appointment update failed",
          type: "error",
        }),
      );
    } catch (err) {
      // thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Appointment update failed",
          type: "error",
        }),
      );
    }
  },
);

export const clinicReassignAppointment = createAsyncThunk(
  "clinicReassignAppointment",
  async (data, thunkAPI) => {
    const profile = JSON.parse(localStorage.getItem("user"));
    try {
      // thunkAPI.dispatch(showLoader());
      const res = await api({
        contentType: true,
        auth: true,
        // formData: true,
      }).put(
        `/clinic/book/appointment/${data?.appointmentId}/reassign`,
        // data?.form
        data?.data,
      );
      if (res?.status === 200 || res?.status === 201) {
        // thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({
            message: "Appointment updated successfully!",
            type: "success",
          }),
        );
        return true;
      }
      // thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Appointment update failed",
          type: "error",
        }),
      );
    } catch (err) {
      // thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Appointment update failed",
          type: "error",
        }),
      );
    }
  },
);

export const updateBillingItemsByPaymentId = createAsyncThunk(
  "updateBillingItemsByPaymentId",
  async (data, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).put(
        `/appointment/clinic/payments/${data?.paymentId}`,
        data?.data,
      );
      if (res?.status === 200) {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({
            message: "Payment Item updated successfully",
            type: "success",
          }),
        );
        return true;
      }
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Payment Item update failed",
          type: "error",
        }),
      );
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Payment Item update failed",
          type: "error",
        }),
      );
    }
  },
);

export const applyTotalDiscountByPayAndDetailId = createAsyncThunk(
  "applyTotalDiscountByPayAndDetailId",
  async ({ paymentId, data }, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).put(
        `/clinic/payments/${paymentId}/discount`,
        data,
      );
      if (res?.status === 200) {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({
            message: "Discount applied successfully",
            type: "success",
          }),
        );
        return true;
      }
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Apply discount getting failed",
          type: "error",
        }),
      );
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Apply discount getting failed",
          type: "error",
        }),
      );
    }
  },
);

export const deletePaymentItemById = createAsyncThunk(
  "deletePaymentItemById",
  async (id, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).delete(
        `appointment/clinic/user/service/${id}`,
      );
      if (res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({
            message: "Payment Item removed successfully",
            type: "success",
          }),
        );
        return true;
      }
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Error encountered!",
          type: "error",
        }),
      );
      return false;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Error encountered!",
          type: "error",
        }),
      );
    }
  },
);

export const getRecentTransactionsPayment = createAsyncThunk(
  "getRecentTransactionsPayment",
  async (url = "", thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).get(
        `appointment/clinic/payments${url}`,
      );
      if (res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        return res.data.data;
      } else if (res.status !== 200) {
        thunkAPI.dispatch(hideLoader());
      }
      thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
    }
  },
);

export const getAllClinicPayment = createAsyncThunk(
  "getAllClinicPayment",
  async (url = "", thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).get(
        `appointment/clinic/payments${url}`,
      );
      if (res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        return res.data;
      } else if (res.status !== 200) {
        thunkAPI.dispatch(hideLoader());
      }
      thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
    }
  },
);

export const getAllClinicPaymentList = createAsyncThunk(
  "getAllClinicPaymentList",
  async (url = "", thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).get(
        `appointment/clinic/payments${url}`,
      );
      if (res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        return res?.data?.data;
      } else if (res.status !== 200) {
        thunkAPI.dispatch(hideLoader());
      }
      thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
    }
  },
);

export const getAllClinicPaymentOfHugeRecord = createAsyncThunk(
  "getAllClinicPaymentOfHugeRecord",
  async (url = "", thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).get(
        `appointment/clinic/payments${url}`,
      );
      if (res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        return res.data;
      } else if (res.status !== 200) {
        thunkAPI.dispatch(hideLoader());
      }
      thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
    }
  },
);

export const getClinicPaymentsByFilter = createAsyncThunk(
  "getClinicPaymentsByFilter",
  async (data, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).post(
        `/payments/search`,
        data,
      );
      if (res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        return res.data;
      } else if (res.status !== 200) {
        thunkAPI.dispatch(hideLoader());
      }
      thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
    }
  },
);

export const getClinicPaymentsForSuggestion = createAsyncThunk(
  "getClinicPaymentsForSuggestion",
  async (data, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).post(
        `/payments/search`,
        data,
      );
      if (res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        return res.data;
      } else if (res.status !== 200) {
        thunkAPI.dispatch(hideLoader());
      }
      thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
    }
  },
);

export const getNewReturnPayments = createAsyncThunk(
  "getNewReturnPayments",
  async (url = "type=sales", thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).get(
        `/clinic/return-payments${url}`,
      );
      if (res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        return res?.data;
      } else if (res.status !== 200) {
        thunkAPI.dispatch(hideLoader());
      }
      thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
    }
  },
);

export const getReturnPayments = createAsyncThunk(
  "getReturnPayments",
  async (url = "", thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).get(
        `/appointment/clinic/payments${url}`,
      );
      if (res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        return res?.data;
      } else if (res.status !== 200) {
        thunkAPI.dispatch(hideLoader());
      }
      thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
    }
  },
);

export const getSlotById = createAsyncThunk(
  "getSlotById",
  async (data, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).get(
        `clinic/doctor/${data?.vetId}/slot/date${data?.url}`,
      );
      if (res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        return res.data.data;
      } else if (res.status !== 200) {
        thunkAPI.dispatch(hideLoader());
      }
      thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
    }
  },
);

export const doctorSlotDayByDisable = createAsyncThunk(
  "doctorSlotDayByDisable",
  async (data, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).put(
        `clinic/slots/doctor/${data?.vetId}/slotday/${data?.slotdayId}`,
      );
      if (res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        return res.data;
      } else if (res.status !== 200) {
        thunkAPI.dispatch(hideLoader());
      }
      thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
    }
  },
);

export const doctorSlotTimeByDisable = createAsyncThunk(
  "doctorSlotTimeByDisable",
  async (data, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).put(
        `doctor/slot/time`,
        data,
      );
      if (res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({
            message: "Changes updated successfully!",
            type: "success",
          }),
        );
        return res.data;
      }
      thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Error encountered!",
          type: "error",
        }),
      );
    }
  },
);

export const getClinics = createAsyncThunk(
  "getClinics",
  async (url = "", thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).get(
        `getall/clinic${url ? `${url}` : ""}`,
      );
      if (res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        return res.data.data;
      } else if (res.status !== 200) {
        thunkAPI.dispatch(hideLoader());
      }
      thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
    }
  },
);

export const getClinicDashboardData = createAsyncThunk(
  "getClinicDashboardData",
  async ({ type, url = "" }, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).get(
        `appointments/clinic/doctors?type=${type}${url}`,
      );
      if (res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        return res.data.data;
      } else if (res.status !== 200) {
        thunkAPI.dispatch(hideLoader());
      }
      thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Error encountered!",
          type: "error",
        }),
      );
    }
  },
);

export const getClinicDashboardDataWoLoader = createAsyncThunk(
  "getClinicDashboardDataWoLoader",
  async ({ type, url = "" }, thunkAPI) => {
    try {
      // thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).get(
        `appointments/clinic/doctors?type=${type}${url}`,
      );
      if (res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        return res.data.data;
      } else if (res.status !== 200) {
        thunkAPI.dispatch(hideLoader());
      }
      thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Error encountered!",
          type: "error",
        }),
      );
    }
  },
);

export const getDiagnosticDashboardData = createAsyncThunk(
  "getDiagnosticDashboardData",
  async ({ type = "outpatient", url = "" }, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).get(
        `/appointments/clinic/doctors/radiology?type=${type}${url}`,
      );
      if (res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        return res?.data?.data;
      } else if (res.status !== 200) {
        thunkAPI.dispatch(hideLoader());
      }
      thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Error encountered!",
          type: "error",
        }),
      );
    }
  },
);

export const getPharmacyDashboardData = createAsyncThunk(
  "getPharmacyDashboardData",
  async ({ type = "outpatient", url = "" }, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).get(
        `/appointments/clinic/doctors/prescription?type=${type}${url}`,
      );
      if (res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        return res?.data?.data;
      } else if (res.status !== 200) {
        thunkAPI.dispatch(hideLoader());
      }
      thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Error encountered!",
          type: "error",
        }),
      );
    }
  },
);

export const getClinicOtherUsers = createAsyncThunk(
  "getClinicOtherUsers",
  async (_, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).get(
        "/clinic/doctors?type=other",
      );
      if (res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        return res?.data?.data;
      } else if (res.status !== 200) {
        thunkAPI.dispatch(hideLoader());
      }
      thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Error encountered!",
          type: "error",
        }),
      );
    }
  },
);

export const updateClinicOtherUsers = createAsyncThunk(
  "updateClinicOtherUsers",
  async (data, thunkAPI) => {
    try {
      const d = new FormData();
      d.append("access", data?.access);
      thunkAPI.dispatch(showLoader());
      const res = await api({
        contentType: true,
        auth: true,
        formData: true,
      }).put(`/clinic/delete/otherusers/${data?.userId}`, d);
      if (res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        return res?.data?.data;
      } else if (res.status !== 200) {
        thunkAPI.dispatch(hideLoader());
      }
      thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Error encountered!",
          type: "error",
        }),
      );
    }
  },
);

export const getClinicAppointmentTypesByUserId = createAsyncThunk(
  "getClinicAppointmentTypesByUserId",
  async (userId, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).get(
        `hospitals/appointments/${userId}`,
      );
      if (res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        return res?.data?.appointmentType;
      } else if (res.status !== 200) {
        thunkAPI.dispatch(hideLoader());
      }
      thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Error encountered!",
          type: "error",
        }),
      );
    }
  },
);

export const getClinicTerms = createAsyncThunk(
  "getClinicTerms",
  async (_, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).get(
        "/clinic/terms",
      );
      if (res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        return res?.data?.data;
      }
      thunkAPI.dispatch(hideLoader());
      return false;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Error encountered!",
          type: "error",
        }),
      );
    }
  },
);

export const getDoctorsByClinicId = createAsyncThunk(
  "getDoctorsByClinicId",
  async (clinicId, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).get(
        `admin/getdoctorsbyhospital/${clinicId}`,
      );
      if (res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        return res.data.hospital;
      } else if (res.status !== 200) {
        thunkAPI.dispatch(hideLoader());
      }
      thunkAPI.dispatch(hideLoader());
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Error encountered!",
          type: "error",
        }),
      );
    }
  },
);

export const getAppointsmentsByClinic = createAsyncThunk(
  "getAppointsmentsByClinic",
  async (url = "", thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).get(
        `/clinic/doctors/appointments${url}`,
      );
      if (res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        return {
          data: res?.data,
          today: url?.includes(
            `type=date&date=${moment(new Date()).format("YYYY-MM-DD")}`,
          ),
        };
      } else if (res.status !== 200) {
        thunkAPI.dispatch(hideLoader());
      }
      thunkAPI.dispatch(hideLoader());
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
    }
  },
);

export const getAppointsmentsByClinicWoLoader = createAsyncThunk(
  "getAppointsmentsByClinicWoLoader",
  async (url = "", thunkAPI) => {
    try {
      // thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).get(
        `/clinic/doctors/appointments${url}`,
      );
      if (res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        return {
          data: res?.data,
          today: url?.includes(
            `type=date&date=${moment(new Date()).format("YYYY-MM-DD")}`,
          ),
        };
      } else if (res.status !== 200) {
        thunkAPI.dispatch(hideLoader());
      }
      thunkAPI.dispatch(hideLoader());
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
    }
  },
);

export const getAppointmentsByClinicAndFilter = createAsyncThunk(
  "getAppointmentsByClinicAndFilter",
  async (data, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).post(
        `/appointments/filter-list`,
        data,
      );
      if (res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        return res?.data;
      } else if (res.status !== 200) {
        thunkAPI.dispatch(hideLoader());
      }
      thunkAPI.dispatch(hideLoader());
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
    }
  },
);

export const getAppointmentsByClinicForSuggestion = createAsyncThunk(
  "getAppointmentsByClinicForSuggestion",
  async (data, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).post(
        `/appointments/filter-list`,
        data,
      );
      if (res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        return res?.data;
      } else if (res.status !== 200) {
        thunkAPI.dispatch(hideLoader());
      }
      thunkAPI.dispatch(hideLoader());
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
    }
  },
);

export const getDoctorAppointsmentsById = createAsyncThunk(
  "getDoctorAppointsmentsById",
  async (data, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).get(
        `/appointments/clinic/doctor/${data?.vetId}?type=${data?.type}`,
      );
      if (res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        return res.data.data;
      } else if (res.status !== 200) {
        thunkAPI.dispatch(hideLoader());
      }
      thunkAPI.dispatch(hideLoader());
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
    }
  },
);

export const getVetAppointmentsByIdAndFilter = createAsyncThunk(
  "getVetAppointmentsByIdAndFilter",
  async (url = "", thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).get(
        `/appointments/clinic/doctor/${url}`,
      );
      if (res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        return {
          data: res?.data?.data,
          today: url?.includes(
            `type=date&date=${moment(new Date()).format("YYYY-MM-DD")}`,
          ),
        };
      } else if (res.status !== 200) {
        thunkAPI.dispatch(hideLoader());
      }
      thunkAPI.dispatch(hideLoader());
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
    }
  },
);

export const getVetAppointmentsByIdAndFilterWoLoader = createAsyncThunk(
  "getVetAppointmentsByIdAndFilterWoLoader",
  async (url = "", thunkAPI) => {
    try {
      // thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).get(
        `/appointments/clinic/doctor/${url}`,
      );
      if (res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        return {
          data: res?.data?.data,
          today: url?.includes(
            `type=date&date=${moment(new Date()).format("YYYY-MM-DD")}`,
          ),
        };
      } else if (res.status !== 200) {
        thunkAPI.dispatch(hideLoader());
      }
      thunkAPI.dispatch(hideLoader());
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
    }
  },
);

export const getVetUpcomingAppointmentsById = createAsyncThunk(
  "getVetUpcomingAppointmentsById",
  async (vetId, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).get(
        `/appointments/clinic/doctor/${vetId}?type=upcomming`,
      );
      if (res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        return res.data.data;
      } else if (res.status !== 200) {
        thunkAPI.dispatch(hideLoader());
      }
      thunkAPI.dispatch(hideLoader());
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
    }
  },
);

export const getPetAppointsmentsById = createAsyncThunk(
  "getPetAppointsmentsById",
  async (_, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).get(
        `/appointments/doctor/pet/2`,
      );
      if (res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        return res.data.data;
      } else if (res.status !== 200) {
        thunkAPI.dispatch(hideLoader());
      }
      thunkAPI.dispatch(hideLoader());
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
    }
  },
);

export const getMedicalOrdersByClinic = createAsyncThunk(
  "getMedicalOrdersByClinic",
  async (url = "", thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).get(
        `medicalorder/getallmedicalorder${url ? url : ""}`,
      );
      if (res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        return res?.data;
      }
      thunkAPI.dispatch(hideLoader());
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
    }
  },
);

export const getClinicOpeningHours = createAsyncThunk(
  "getClinicOpeningHours",
  async (_, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).get(
        "/clinic/globaldays",
      );
      thunkAPI.dispatch(hideLoader());
      if (res.status === 200) {
        return res?.data?.data;
      }
      return false;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
    }
  },
);

export const getClinicDetails = createAsyncThunk(
  "getClinicDetails",
  async (_, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).get("/clinic");
      thunkAPI.dispatch(hideLoader());
      if (res.status === 200) {
        return res?.data?.data;
      }
      return false;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
    }
  },
);

export const getClinicDetailsWoLoader = createAsyncThunk(
  "getClinicDetailsWoLoader",
  async (_, thunkAPI) => {
    try {
      // thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).get("/clinic");
      thunkAPI.dispatch(hideLoader());
      if (res.status === 200) {
        return res?.data?.data;
      }
      return false;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
    }
  },
);

export const getClinicHolidays = createAsyncThunk(
  "getClinicHolidays",
  async (_, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).get(
        "/clinic/hollidays",
      );
      thunkAPI.dispatch(hideLoader());
      if (res.status === 200) {
        return res?.data?.data;
      }
      return false;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
    }
  },
);

export const updateClinicOpeningHours = createAsyncThunk(
  "updateClinicOpeningHours",
  async (data, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).post(
        `/clinic/globaldays`,
        data?.data,
      );
      if (res.status === 201 || res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({
            message: "Clinic Hours Updated",
            type: "success",
          }),
        );
        return true;
      } else if (res.status !== 201) {
        thunkAPI.dispatch(hideLoader());
      }
      thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Error encountered!",
          type: "error",
        }),
      );
    }
  },
);

export const createClinicDoctors = createAsyncThunk(
  "createClinicDoctors",
  async (data, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({
        contentType: true,
        auth: true,
        formData: true,
      }).post(`/clinic/doctors`, data);

      thunkAPI.dispatch(hideLoader());

      if (res.status === 201 || res.status === 200) {
        return res;
      }
      return null;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      return err;
    }
  },
);

export const createOthers = createAsyncThunk(
  "createOthers",
  async (data, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({
        contentType: true,
        auth: true,
        formData: true,
      }).post(`/other/register`, data);
      if (res.status === 201 || res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        return res;
      }
      thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Error encountered!",
          type: "error",
        }),
      );
    }
  },
);

export const createClinicSlots = createAsyncThunk(
  "createClinicSlots",
  async (data, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).post(
        `/clinic/slots/doctor/${data?.vetId}`,
        data?.data,
      );

      if (res.status === 201 || res.status === 200) {
        thunkAPI.dispatch(
          showSnackBar({
            message: "Changes updated successfully!",
            type: "success",
          }),
        );
        thunkAPI.dispatch(hideLoader());
        return true;
      }
      thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: err?.response?.data?.message ?? "Error encountered!",
          type: "error",
        }),
      );
    }
  },
);

export const createUserPet = createAsyncThunk(
  "createUserPet",
  async (data, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({
        contentType: true,
        auth: true,
        formData: true,
      }).post(`/clinic/user/pet`, data);

      if (res.status === 201 || res.status === 200) {
        thunkAPI.dispatch(hideLoader());

        return res;
      } else if (res.status !== 201) {
        thunkAPI.dispatch(hideLoader());
      }
      thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: err?.response?.data?.message ?? "Error encountered!",
          type: "error",
        }),
      );
    }
  },
);

export const updateClinicHolidays = createAsyncThunk(
  "updateClinicHolidays",
  async (data, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).post(
        "/clinic/hollidays",
        data,
      );
      if (res.status === 201 || res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({
            message: "Clinic Holidays Updated",
            type: "success",
          }),
        );
        return true;
      } else if (res.status !== 201) {
        thunkAPI.dispatch(hideLoader());
      }
      thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Error encountered!",
          type: "error",
        }),
      );
    }
  },
);

export const deleteClinicHolidayById = createAsyncThunk(
  "deleteClinicHolidayById",
  async (holidayId, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).delete(
        `/clinic/hollidays/${holidayId}`,
      );
      if (res.status === 201 || res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({
            message: "Clinic Holiday Deleted",
            type: "success",
          }),
        );
        return true;
      } else if (res.status !== 201 || res.status !== 200) {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({
            message: "Error encountered!",
            type: "error",
          }),
        );
      }
      thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Error encountered!",
          type: "error",
        }),
      );
    }
  },
);

export const addClinic = createAsyncThunk(
  "addClinic",
  async (data, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({
        contentType: true,
        auth: true,
        formData: true,
      }).post("/clinic/register", data);
      if (res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({
            message: "Clinic Added successfully",
            type: "success",
          }),
        );
        return res.data.data;
      } else if (res.status === 400) {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({ message: "Error encountered!", type: "error" }),
        );
      }
      thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({ message: "Error encountered!", type: "error" }),
      );
    }
  },
);

export const updateClinic = createAsyncThunk(
  "updateClinic",
  async (form, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({
        contentType: true,
        auth: true,
        formData: true,
      }).put("/clinic", form);
      if (res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({
            message: "Changes updated successfully!",
            type: "success",
          }),
        );
        return true;
      } else if (res.status === 400) {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({ message: "Error encountered!", type: "error" }),
        );
      }
      thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({ message: "Error encountered!", type: "error" }),
      );
    }
  },
);

export const addTaskByPatientId = createAsyncThunk(
  "addTaskByPatientId",
  async ({ patientId, data }, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({
        contentType: true,
        auth: true,
      }).put(`/inpatient/${patientId}`, data);
      if (res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({
            message: "Task added successfully!",
            type: "success",
          }),
        );
        return true;
      } else {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({ message: "Error encountered!", type: "error" }),
        );
      }
      return null;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({ message: "Error encountered!", type: "error" }),
      );
    }
  },
);

export const getInpatientAlertsByAppointmentId = createAsyncThunk(
  "getInpatientAlertsByAppointmentId",
  async (apntId, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({
        contentType: true,
        auth: true,
      }).get(`/getall/appointment/${apntId}/inpatient-alerts`);
      if (res.status === 200 || res.status === 201) {
        thunkAPI.dispatch(hideLoader());
        return res?.data?.data;
      } else {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({
            message: "Inpatient Alerts getting failed",
            type: "error",
          }),
        );
      }
      return null;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Inpatient Alerts getting failed",
          type: "error",
        }),
      );
    }
  },
);

export const getInpatientAlertsByAppointmentIdWoLoader = createAsyncThunk(
  "getInpatientAlertsByAppointmentIdWoLoader",
  async (apntId, thunkAPI) => {
    try {
      // thunkAPI.dispatch(showLoader());
      const res = await api({
        contentType: true,
        auth: true,
      }).get(`/getall/appointment/${apntId}/inpatient-alerts`);
      if (res.status === 200 || res.status === 201) {
        thunkAPI.dispatch(hideLoader());
        return res?.data?.data;
      } else {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({
            message: "Inpatient Alerts getting failed",
            type: "error",
          }),
        );
      }
      return null;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Inpatient Alerts getting failed",
          type: "error",
        }),
      );
    }
  },
);

export const getInpatientTasksByAppointmentId = createAsyncThunk(
  "getInpatientTasksByAppointmentId",
  async (apntId, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({
        contentType: true,
        auth: true,
      }).get(`/getall/appointment/${apntId}/inpatient-tasks`);
      if (res.status === 200 || res.status === 201) {
        thunkAPI.dispatch(hideLoader());
        return res?.data?.data;
      } else {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({
            message: "Inpatient Tasks getting failed",
            type: "error",
          }),
        );
      }
      return null;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Inpatient Tasks getting failed",
          type: "error",
        }),
      );
    }
  },
);

export const getInpatientSummaryByAppointmentId = createAsyncThunk(
  "getInpatientSummaryByAppointmentId",
  async (apntId, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({
        contentType: true,
        auth: true,
      }).get(`/getall/appointment/${apntId}/inpatient-summary`);
      if (res.status === 200 || res.status === 201) {
        thunkAPI.dispatch(hideLoader());
        return res?.data?.data;
      } else {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({
            message: "Inpatient Summary getting failed",
            type: "error",
          }),
        );
      }
      return null;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Inpatient Summary getting failed",
          type: "error",
        }),
      );
    }
  },
);

export const getInpatientSummaryByAppointmentIdWoLoader = createAsyncThunk(
  "getInpatientSummaryByAppointmentIdWoLoader",
  async (apntId, thunkAPI) => {
    try {
      // thunkAPI.dispatch(showLoader());
      const res = await api({
        contentType: true,
        auth: true,
      }).get(`/getall/appointment/${apntId}/inpatient-summary`);
      if (res.status === 200 || res.status === 201) {
        thunkAPI.dispatch(hideLoader());
        return res?.data?.data;
      } else {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({
            message: "Inpatient Summary getting failed",
            type: "error",
          }),
        );
      }
      return null;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Inpatient Summary getting failed",
          type: "error",
        }),
      );
    }
  },
);

export const updateStatusConsultation = createAsyncThunk(
  "updateStatusConsultation",
  async (data, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({
        contentType: true,
        auth: true,
      }).put("/clinic/terms", data);
      if (res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({
            message: "Clinic Terms Updated successfully",
            type: "success",
          }),
        );
        return true;
      } else if (res.status === 400) {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({ message: "Error encountered!", type: "error" }),
        );
      }
      thunkAPI.dispatch(hideLoader());
      return false;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({ message: "Error encountered!", type: "error" }),
      );
    }
  },
);

export const updateMedicineFeesByMedicationId = createAsyncThunk(
  "updateMedicineFeesByMedicationId",
  async ({ medicationId, data }, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).put(
        `medicalorder/updateprescriptionfee/${medicationId}`,
        data,
      );
      if (res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({
            message: "Medical fees updated successfully!...",
            type: "success",
          }),
        );
        return true;
      }
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Error encountered!",
          type: "error",
        }),
      );
      return false;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Error encountered!",
          type: "error",
        }),
      );
    }
  },
);

export const createCv = createAsyncThunk("createCv", async (data, thunkAPI) => {
  try {
    thunkAPI.dispatch(showLoader());
    const res = await api({
      contentType: true,
      auth: true,
      formData: true,
    }).patch("admin/clinic/import", data?.form);
    if (res.status === 201) {
      thunkAPI.dispatch(hideLoader());
      return true;
    } else if (res.status === 400) {
      thunkAPI.dispatch(hideLoader());
    }
    thunkAPI.dispatch(hideLoader());
    return null;
  } catch (error) {
    thunkAPI.dispatch(hideLoader());
  }
});

export const addSlotFromConsultation = createAsyncThunk(
  "addSlotFromConsultation",
  async (data, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({
        contentType: true,
        auth: true,
      }).post("/clinicslot", data);
      if (res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({
            message: "Clinic Slot Added successfully",
            type: "success",
          }),
        );
        return true;
      } else if (res.status === 400) {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({ message: "Error encountered!", type: "error" }),
        );
      }
      thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({ message: "Error encountered!", type: "error" }),
      );
    }
  },
);

export const updateServiceStatusByIds = createAsyncThunk(
  "updateServiceStatusByIds",
  async (data, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({
        contentType: true,
        auth: true,
      }).put("/clinic/service/enable", data);
      if (res.status === 201 || res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({
            message: "Service Status updated successfully!",
            type: "success",
          }),
        );
        return true;
      } else if (res.status === 400) {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({ message: "Error encountered!", type: "error" }),
        );
      }
      thunkAPI.dispatch(hideLoader());
      return false;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({ message: "Error encountered!", type: "error" }),
      );
    }
  },
);

export const createClinicService = createAsyncThunk(
  "createClinicService",
  async (data, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({
        contentType: true,
        auth: true,
        // }).post("/clinic/service", data);
      }).post("/clinic/new/service", data);
      if (res.status === 201 || res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({
            message: "Changes updated successfully!",
            type: "success",
          }),
        );
        return true;
      } else if (res.status === 400) {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({ message: "Error encountered!", type: "error" }),
        );
      }
      thunkAPI.dispatch(hideLoader());
      return false;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({ message: "Error encountered!", type: "error" }),
      );
    }
  },
);

export const getServiceCategoryByType = createAsyncThunk(
  "getServiceCategoryByType",
  async (type = "medical", thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).get(
        `/service/category?type=${type}`,
      );
      if (res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        return res?.data?.data;
      } else if (res.status !== 200) {
        thunkAPI.dispatch(hideLoader());
      }
      thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Error encountered!",
          type: "error",
        }),
      );
    }
  },
);

export const getServiceCategoryByTypeWOLoader = createAsyncThunk(
  "getServiceCategoryByTypeWOLoader",
  async (url = "type=medical", thunkAPI) => {
    try {
      // thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).get(
        `/service/category${url}`,
      );
      if (res.status === 200) {
        // thunkAPI.dispatch(hideLoader());
        return res?.data?.data;
      }
      // thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      // thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Error encountered!",
          type: "error",
        }),
      );
    }
  },
);

export const getServices = createAsyncThunk(
  "getServices",
  async (url = "", thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).get(
        `/clinic/service${url}`,
      );
      if (res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        return res?.data;
      } else if (res.status !== 200) {
        thunkAPI.dispatch(hideLoader());
      }
      thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Error encountered!",
          type: "error",
        }),
      );
    }
  },
);

export const getServicesByFilter = createAsyncThunk(
  "getServicesByFilter",
  async (data, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).post(
        `/clinic/services/search`,
        data,
      );
      if (res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        return res?.data;
      } else if (res.status !== 200) {
        thunkAPI.dispatch(hideLoader());
      }
      thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Error encountered!",
          type: "error",
        }),
      );
    }
  },
);

export const getAppointmentHistoriesByPetId = createAsyncThunk(
  "getAppointmentHistoriesByPetId",
  async (petId, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).get(
        `/clinic/appointment/history/pet/${petId}`,
      );
      if (res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        return res?.data?.data;
      }
      thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Error encountered!",
          type: "error",
        }),
      );
    }
  },
);

export const getServicesWoLoader = createAsyncThunk(
  "getServicesWoLoader",
  async (url = "", thunkAPI) => {
    try {
      // thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).get(
        `/clinic/service${url}`,
      );
      if (res.status === 200) {
        // thunkAPI.dispatch(hideLoader());
        return res?.data;
      } else if (res.status !== 200) {
        // thunkAPI.dispatch(hideLoader());
      }
      // thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      // thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Error encountered!",
          type: "error",
        }),
      );
    }
  },
);

export const getVaccinationList = createAsyncThunk(
  "getVaccinationList",
  async (url = "", thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).get(
        `/clinic/product?filter=Vaccines${url}`,
      );
      if (res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        return res?.data?.data;
      } else if (res.status !== 200) {
        thunkAPI.dispatch(hideLoader());
      }
      thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Error encountered!",
          type: "error",
        }),
      );
    }
  },
);

export const getDewormingList = createAsyncThunk(
  "getDewormingList",
  async (url = "", thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).get(
        `/clinic/product?filter=Deworming${url}`,
      );
      if (res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        return res?.data?.data;
      } else if (res.status !== 200) {
        thunkAPI.dispatch(hideLoader());
      }
      thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Error encountered!",
          type: "error",
        }),
      );
    }
  },
);

export const getFleaTreatmentList = createAsyncThunk(
  "getFleaTreatmentList",
  async (url = "", thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).get(
        `/clinic/product?filter=Flea & Tick Treatment${url}`,
      );
      if (res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        return res?.data?.data;
      } else if (res.status !== 200) {
        thunkAPI.dispatch(hideLoader());
      }
      thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Error encountered!",
          type: "error",
        }),
      );
    }
  },
);

export const getDiagnosisList = createAsyncThunk(
  "getDiagnosisList",
  async (url = "", thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).get(
        `/clinic/service?filter=Diagnostics${url}`,
      );
      if (res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        return res?.data?.data;
      } else if (res.status !== 200) {
        thunkAPI.dispatch(hideLoader());
      }
      thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Error encountered!",
          type: "error",
        }),
      );
    }
  },
);

export const getDiagnosisListWoLoader = createAsyncThunk(
  "getDiagnosisListWoLoader",
  async (url = "", thunkAPI) => {
    try {
      // thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).get(
        `/clinic/service?filter=Diagnostics${url}`,
      );
      if (res.status === 200) {
        // thunkAPI.dispatch(hideLoader());
        return res?.data?.data;
      } else if (res.status !== 200) {
        // thunkAPI.dispatch(hideLoader());
      }
      // thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      // thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Error encountered!",
          type: "error",
        }),
      );
    }
  },
);

export const deleteClinicService = createAsyncThunk(
  "deleteClinicService",
  async (id, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).delete(
        `/clinic/service/${id}`,
      );
      if (res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({
            message: "Clinic Service remove successfully",
            type: "success",
          }),
        );
        return true;
      }
      thunkAPI.dispatch(hideLoader());
      return false;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Error encountered!",
          type: "error",
        }),
      );
    }
  },
);

export const editClinicService = createAsyncThunk(
  "editClinicService",
  async (data, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({
        contentType: true,
        auth: true,
      }).put(`/clinic/new/service/${data?.id}`, data?.data);
      // }).put(`/clinic/service/${data?.id}`, data?.data);

      if (res.status === 200 || res?.status === 201) {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({
            message: "Changes updated successfully!",
            type: "success",
          }),
        );
        return true;
      } else if (res.status === 400) {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({ message: "Error encountered!", type: "error" }),
        );
      }
      thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({ message: "Error encountered!", type: "error" }),
      );
    }
  },
);

export const getRolesAndAccess = createAsyncThunk(
  "getRolesAndAccess",
  async (_, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).get(
        `hospitals/user/get`,
      );
      if (res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        return res.data.clinicUserList;
      } else if (res.status !== 200) {
        thunkAPI.dispatch(hideLoader());
      }
      thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Error encountered!",
          type: "error",
        }),
      );
    }
  },
);

export const getUnitType = createAsyncThunk(
  "getUnitType",
  async (_, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).get(
        `/clinic/unit`,
      );
      if (res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        return res.data.data;
      } else if (res.status !== 200) {
        thunkAPI.dispatch(hideLoader());
      }
      thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Error encountered!",
          type: "error",
        }),
      );
    }
  },
);

export const editRoleAndAccess = createAsyncThunk(
  "editRoleAndAccess",
  async (data, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({
        contentType: true,
        auth: true,
      }).patch(`/hospitals/user/${data?.id}`, data?.data);
      if (res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({
            message: "Clinic Roles Edit successfully",
            type: "success",
          }),
        );
        thunkAPI.dispatch(getRolesAndAccess());
        return true;
      } else if (res.status === 400) {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({ message: "Error encountered!", type: "error" }),
        );
      }
      thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({ message: "Error encountered!", type: "error" }),
      );
    }
  },
);

export const createNewProduct = createAsyncThunk(
  "createNewProduct",
  async (data, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({
        contentType: true,
        auth: true,
      }).post("/clinic/product", data);
      if (res.status === 201 || res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({
            message: "Product Added successfully",
            type: "success",
          }),
        );
        return true;
      } else if (res.status === 400) {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({ message: "Error encountered!", type: "error" }),
        );
      }
      thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({ message: "Error encountered!", type: "error" }),
      );
    }
  },
);

export const createStock = createAsyncThunk(
  "createStock",
  async (data, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).post(
        "/clinic/stock",
        data,
      );
      if (res.status === 201 || res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({
            message: "Stock Added successfully!",
            type: "success",
          }),
        );
        return true;
      } else if (res.status === 400) {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({ message: "Error encountered!", type: "error" }),
        );
      }
      thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({ message: "Error encountered!", type: "error" }),
      );
    }
  },
);

export const updateStockStatusByIds = createAsyncThunk(
  "updateStockStatusByIds",
  async (data, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).put(
        "/clinic/stock/enable",
        data,
      );
      if (res.status === 201 || res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({
            message: "Stock Status updated successfully!",
            type: "success",
          }),
        );
        return true;
      } else if (res.status === 400) {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({ message: "Error encountered!", type: "error" }),
        );
      }
      thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({ message: "Error encountered!", type: "error" }),
      );
    }
  },
);

export const createStocks = createAsyncThunk(
  "createStocks",
  async (data, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).post(
        "/clinic/stocks",
        data,
      );
      if (res.status === 201 || res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({
            message: "Stocks Added successfully!",
            type: "success",
          }),
        );
        return true;
      } else if (res.status === 400) {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({ message: "Error encountered!", type: "error" }),
        );
      }
      thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({ message: "Error encountered!", type: "error" }),
      );
    }
  },
);

export const createStocksForPending = createAsyncThunk(
  "createStocksForPending",
  async (data, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).post(
        "/clinic/stocks/pending",
        data,
      );
      if (res.status === 201 || res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({
            message: "Stocks Added successfully!",
            type: "success",
          }),
        );
        return true;
      } else if (res.status === 400) {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({ message: "Error encountered!", type: "error" }),
        );
      }
      thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({ message: "Error encountered!", type: "error" }),
      );
    }
  },
);

export const updateStocks = createAsyncThunk(
  "updateStocks",
  async (data, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).put(
        "/clinic/stocks",
        data,
      );
      if (res.status === 201 || res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({
            message: "Stocks Updated successfully!",
            type: "success",
          }),
        );
        return true;
      } else if (res.status === 400) {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({ message: "Error encountered!", type: "error" }),
        );
      }
      thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({ message: "Error encountered!", type: "error" }),
      );
    }
  },
);

export const updateStocksByIdAndBatchId = createAsyncThunk(
  "updateStocksByIdAndBatchId",
  async ({ stockId, batchId, data }, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).put(
        `/clinic/stock/${stockId}/batch/${batchId}`,
        data,
      );
      if (res.status === 201 || res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({
            message: "Stocks Updated successfully!",
            type: "success",
          }),
        );
        return true;
      } else if (res.status === 400) {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({ message: "Error encountered!", type: "error" }),
        );
      }
      thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({ message: "Error encountered!", type: "error" }),
      );
    }
  },
);

export const updateStockWithBatchList = createAsyncThunk(
  "updateStockWithBatchList",
  async ({ stockId, data }, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).put(
        `/clinic/stock/${stockId}/multiple/batch`,
        data,
      );
      if (res.status === 201 || res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({
            message: "Stocks Updated successfully!",
            type: "success",
          }),
        );
        return true;
      } else if (res.status === 400) {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({ message: "Error encountered!", type: "error" }),
        );
      }
      thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({ message: "Error encountered!", type: "error" }),
      );
    }
  },
);

export const getStockAdjust = createAsyncThunk(
  "getStockAdjust",
  async (_, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).get(
        "/clinic/stock/adjusment",
      );
      if (res.status === 201 || res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        return res?.data;
      } else if (res.status === 400) {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({ message: "Error encountered!", type: "error" }),
        );
      }
      thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({ message: "Error encountered!", type: "error" }),
      );
    }
  },
);

export const updateBulkPriceForStock = createAsyncThunk(
  "updateBulkPriceForStock",
  async (data, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).post(
        "/clinic/stocks/bulk/price-update",
        data,
      );
      if (res.status === 201 || res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({
            message: "Price updated successfully!",
            type: "success",
          }),
        );
        return true;
      } else if (res.status === 400) {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({ message: "Price update failed!", type: "error" }),
        );
      }
      thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({ message: "Price update failed!", type: "error" }),
      );
    }
  },
);

export const updateBulkPriceForService = createAsyncThunk(
  "updateBulkPriceForService",
  async (data, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).post(
        "/clinic/services/bulk/price-update",
        data,
      );
      if (res.status === 201 || res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({
            message: "Price updated successfully!",
            type: "success",
          }),
        );
        return true;
      } else if (res.status === 400) {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({ message: "Price update failed!", type: "error" }),
        );
      }
      thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({ message: "Price update failed!", type: "error" }),
      );
    }
  },
);

export const updateStockAdjust = createAsyncThunk(
  "updateStockAdjust",
  async (data, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).post(
        "/clinic/stock/adjusment",
        data,
      );
      if (res.status === 201 || res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({
            message: "Stocks Adjust Added successfully!",
            type: "success",
          }),
        );
        return true;
      } else if (res.status === 400) {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({ message: "Error encountered!", type: "error" }),
        );
      }
      thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({ message: "Error encountered!", type: "error" }),
      );
    }
  },
);

export const updateStockFilesById = createAsyncThunk(
  "updateStockFilesById",
  async ({ stockId, form }, thunkAPI) => {
    try {
      // thunkAPI.dispatch(showLoader());
      const res = await api({
        contentType: true,
        auth: true,
        formData: true,
      }).post(`/clinic/stock/${stockId}/file-upload`, form);
      if (res.status === 201 || res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        return true;
      } else {
        const reRes = await api({
          contentType: true,
          auth: true,
          formData: true,
        }).post(`/clinic/stock/${stockId}/file-upload`, form);
        if (reRes.status === 201 || reRes.status === 200) {
          thunkAPI.dispatch(hideLoader());
          return true;
        } else {
          thunkAPI.dispatch(hideLoader());
        }
        thunkAPI.dispatch(hideLoader());
      }
      return null;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
    }
  },
);

export const deleteStockById = createAsyncThunk(
  "deleteStockById",
  async (stockId, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).delete(
        `clinic/stock/${stockId}`,
      );
      if (res.status === 201 || res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({
            message: "Stock Deleted successfully!",
            type: "success",
          }),
        );
        return true;
      } else if (res.status === 400) {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({ message: "Error encountered!", type: "error" }),
        );
      }
      thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({ message: "Error encountered!", type: "error" }),
      );
    }
  },
);

export const deleteStockByIds = createAsyncThunk(
  "deleteStockByIds",
  async (data, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).post(
        `/clinic/stocks/all`,
        data,
      );
      if (res.status === 201 || res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({
            message: "Stocks Deleted successfully!",
            type: "success",
          }),
        );
        return true;
      } else if (res.status === 400) {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({ message: "Error encountered!", type: "error" }),
        );
      }
      thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({ message: "Error encountered!", type: "error" }),
      );
    }
  },
);

export const createRoleAndAccess = createAsyncThunk(
  "createRoleAndAccess",
  async (data, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({
        contentType: true,
        auth: true,
        formData: true,
      }).post("/hospitals/user/add", data);
      if (res.status === 201) {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({
            message: "Clinic Roles Added successfully",
            type: "success",
          }),
        );
        thunkAPI.dispatch(getRolesAndAccess());
        return true;
      } else if (res.status === 400) {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({ message: "Error encountered!", type: "error" }),
        );
      }
      thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({ message: "Error encountered!", type: "error" }),
      );
    }
  },
);

export const getSupplier = createAsyncThunk(
  "getSupplier",
  async (url = "", thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).get(
        `/clinic/supplier${url}`,
      );
      if (res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        return res.data;
      } else if (res.status !== 200) {
        thunkAPI.dispatch(hideLoader());
      }
      thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Error encountered!",
          type: "error",
        }),
      );
    }
  },
);

export const getSupplierReturns = createAsyncThunk(
  "getSupplierReturns",
  async (url = "", thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).get(
        `/clinic/supplier${url}`,
      );
      if (res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        return res.data;
      } else if (res.status !== 200) {
        thunkAPI.dispatch(hideLoader());
      }
      thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Error encountered!",
          type: "error",
        }),
      );
    }
  },
);

export const deleteSupplier = createAsyncThunk(
  "deleteSupplier",
  async (id, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).delete(
        `/clinic/supplier/${id}`,
      );
      if (res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({
            message: "Clinic Supplier remove successfully",
            type: "success",
          }),
        );
        return true;
      } else if (res.status !== 200) {
        thunkAPI.dispatch(hideLoader());
      }
      thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Error encountered!",
          type: "error",
        }),
      );
    }
  },
);

export const createSupplier = createAsyncThunk(
  "createSupplier",
  async (data, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({
        contentType: true,
        auth: true,
      }).post("/clinic/supplier", data);
      if (res.status === 201 || res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({
            message: "Supplier created successfully!",
            type: "success",
          }),
        );
        return true;
      } else if (res.status === 400) {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({ message: "Error encountered!", type: "error" }),
        );
      }
      thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({ message: "Error encountered!", type: "error" }),
      );
    }
  },
);

export const deleteProducts = createAsyncThunk(
  "deleteProducts",
  async (id, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).delete(
        `/clinic/product/${id}`,
      );
      if (res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({
            message: "Clinic Product removed successfully",
            type: "success",
          }),
        );
        return true;
      } else if (res.status !== 200) {
        thunkAPI.dispatch(hideLoader());
      }
      thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Error encountered!",
          type: "error",
        }),
      );
    }
  },
);

export const editClinicProduct = createAsyncThunk(
  "editClinicProduct",
  async (data, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({
        contentType: true,
        auth: true,
      }).put(`/clinic/product/${data?.id}`, data?.data);
      if (res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({
            message: "Changes updated successfully!",
            type: "success",
          }),
        );
        return true;
      } else if (res.status === 400) {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({ message: "Error encountered!", type: "error" }),
        );
      }
      thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({ message: "Error encountered!", type: "error" }),
      );
    }
  },
);

export const getProductsByClinic = createAsyncThunk(
  "getProductsByClinic",
  async (url = "", thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).get(
        `/clinic/product${url}`,
      );
      if (res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        return res.data;
      } else if (res.status !== 200) {
        thunkAPI.dispatch(hideLoader());
      }
      thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Error encountered!",
          type: "error",
        }),
      );
    }
  },
);

export const getProductsByClinicWithFilter = createAsyncThunk(
  "getProductsByClinicWithFilter",
  async (url = "", thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).get(
        `/clinic/product${url}`,
      );
      if (res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        return res?.data?.data;
      } else if (res.status !== 200) {
        thunkAPI.dispatch(hideLoader());
      }
      thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Error encountered!",
          type: "error",
        }),
      );
    }
  },
);

export const getStocksByClinic = createAsyncThunk(
  "getStocksByClinic",
  async (url = "", thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).get(
        `/clinic/stock${url}`,
      );
      if (res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        return res.data;
      } else if (res.status !== 200) {
        thunkAPI.dispatch(hideLoader());
      }
      thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Error encountered!",
          type: "error",
        }),
      );
    }
  },
);

export const getStocksByClinicByFilter = createAsyncThunk(
  "getStocksByClinicByFilter",
  async (data, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).post(
        `/clinic/stocks/search`,
        data,
      );
      if (res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        return res.data;
      } else if (res.status !== 200) {
        thunkAPI.dispatch(hideLoader());
      }
      thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Error encountered!",
          type: "error",
        }),
      );
    }
  },
);

export const getPendingStocksByClinic = createAsyncThunk(
  "getPendingStocksByClinic",
  async (url = "", thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).get(
        `/clinic/stock${url}`,
      );
      if (res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        return res.data;
      } else if (res.status !== 200) {
        thunkAPI.dispatch(hideLoader());
      }
      thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Error encountered!",
          type: "error",
        }),
      );
    }
  },
);

export const getClinicStocks = createAsyncThunk(
  "getClinicStocks",
  async (url = "", thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).get(
        `/clinic/stock${url}`,
      );
      if (res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        return res?.data;
      } else if (res.status !== 200) {
        thunkAPI.dispatch(hideLoader());
      }
      thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Error encountered!",
          type: "error",
        }),
      );
    }
  },
);

export const getClinicStocksWoLoader = createAsyncThunk(
  "getClinicStocksWoLoader",
  async (url = "", thunkAPI) => {
    try {
      // thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).get(
        `/clinic/stock${url}`,
      );
      if (res.status === 200) {
        // thunkAPI.dispatch(hideLoader());
        return res?.data;
      } else if (res.status !== 200) {
        // thunkAPI.dispatch(hideLoader());
      }
      // thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      // thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Error encountered!",
          type: "error",
        }),
      );
    }
  },
);

export const updateStockById = createAsyncThunk(
  "updateStockById",
  async (data, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).put(
        `/clinic/stock/${data?.id}`,
        data?.data,
      );
      if (res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({
            message: "Stock updated successfully!",
            type: "success",
          }),
        );
        return true;
      } else if (res.status === 400) {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({
            message: "Error encountered!",
            type: "error",
          }),
        );
      }
      thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({ message: "Error encountered!", type: "error" }),
      );
    }
  },
);

export const updateSupplier = createAsyncThunk(
  "updateSupplier",
  async (data, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({
        contentType: true,
        auth: true,
      }).put(`/clinic/supplier/${data?.id}`, data?.data);
      if (res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({
            message: "Supplier updated successfully!",
            type: "success",
          }),
        );
        return true;
      } else if (res.status === 400) {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({
            message: "Error encountered!",
            type: "error",
          }),
        );
      }
      thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({ message: "Error encountered!", type: "error" }),
      );
    }
  },
);

export const payBill = createAsyncThunk("payBill", async (id, thunkAPI) => {
  try {
    thunkAPI.dispatch(showLoader());
    const res = await api({ contentType: true, auth: true }).get(
      `/paybill/${id}`,
    );
    if (res.status === 200) {
      thunkAPI.dispatch(hideLoader());
      return res.data.billing;
    } else if (res.status !== 200) {
      thunkAPI.dispatch(hideLoader());
    }
    thunkAPI.dispatch(hideLoader());
    return null;
  } catch (err) {
    thunkAPI.dispatch(hideLoader());
  }
});

export const deletePayBill = createAsyncThunk(
  "deletePayBill",
  async (id, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).delete(
        `/paybill/item/${id}`,
      );
      if (res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(payBill());
        thunkAPI.dispatch(
          showSnackBar({
            message: "Clinic Paybill remove successfully",
            type: "success",
          }),
        );
        return res.data;
      } else if (res.status !== 200) {
        thunkAPI.dispatch(hideLoader());
      }
      thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Error encountered!",
          type: "error",
        }),
      );
    }
  },
);

export const createPayBill = createAsyncThunk(
  "createPayBill",
  async (data, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({
        contentType: true,
        auth: true,
      }).post("/paybill/item", data);
      if (res.status === 201) {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({
            message: "Clinic Paybill Added successfully",
            type: "success",
          }),
        );
        return true;
      } else if (res.status === 400) {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({ message: "Error encountered!", type: "error" }),
        );
      }
      thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({ message: "Error encountered!", type: "error" }),
      );
    }
  },
);

export const editPayBill = createAsyncThunk(
  "editPayBill",
  async (data, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({
        contentType: true,
        auth: true,
      }).patch(`/paybill/item/${data?.id}`, data?.data);
      if (res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({
            message: "Clinic Paybill Edited successfully",
            type: "success",
          }),
        );
        return true;
      } else if (res.status === 400) {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({
            message: "Error encountered!",
            type: "error",
          }),
        );
      }
      thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({ message: "Error encountered!", type: "error" }),
      );
    }
  },
);

export const bookPetAppointment = createAsyncThunk(
  "bookPetAppointment",
  async (data, thunkAPI) => {
    try {
      // thunkAPI.dispatch(showLoader());
      const res = await api({
        contentType: true,
        auth: true,
      }).post("/clinic/bookpetappointment", data);
      if (res.status === 201 || res.status === 200) {
        // thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({
            message: "Pet Book Appointment Added successfully",
            type: "success",
          }),
        );
        return true;
      } else if (res.status === 400) {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({
            message: "Error encountered!",
            type: "error",
          }),
        );
      }
      thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Error encountered!",
          type: "error",
        }),
      );
    }
  },
);

export const registerClinicUser = createAsyncThunk(
  "registerClinicUser",
  async (data, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({
        contentType: true,
        auth: true,
        formData: true,
      }).post("/clinic/register/user", data);
      if (res.status === 200) {
        if (res?.data?.status === 400) {
          thunkAPI.dispatch(hideLoader());
          thunkAPI.dispatch(
            showSnackBar({
              message: res?.data?.message,
              type: "error",
            }),
          );
          return res?.data;
        }
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({
            message: "User Added successfully",
            type: "success",
          }),
        );
        return res?.data;
      }
      thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Error encountered!",
          type: "error",
        }),
      );
    }
  },
);

export const updateClinicUserById = createAsyncThunk(
  "updateClinicUserById",
  async (
    { userId, form, successMsg = "User Updated successfully" },
    thunkAPI,
  ) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({
        contentType: true,
        auth: true,
        formData: true,
      }).put(`/clinic/update/user/${userId}`, form);
      if (res.status === 200 || res.status === 201) {
        if (res?.data?.status === 400) {
          thunkAPI.dispatch(hideLoader());
          thunkAPI.dispatch(
            showSnackBar({
              message: res?.data?.message,
              type: "error",
            }),
          );
          return res?.data;
        }
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({
            message: successMsg,
            type: "success",
          }),
        );
        return res?.data;
      }
      thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Error encountered!",
          type: "error",
        }),
      );
    }
  },
);

export const getVetDetailsById = createAsyncThunk(
  "getVetDetailsById",
  async (vetId, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).get(
        `/clinic/doctor/${vetId}`,
      );
      if (res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        return res.data.data;
      } else if (res.status !== 200) {
        thunkAPI.dispatch(hideLoader());
      }
      thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
    }
  },
);

export const getPetBillingById = createAsyncThunk(
  "getPetBillingById",
  async ({ petId, data = { page: 1, itemSize: 5 } }, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).post(
        `/appointment/clinic/payments/pet/${petId}`,
        data,
      );
      if (res.status === 200 || res.status === 201) {
        thunkAPI.dispatch(hideLoader());
        return res.data;
      } else if (res.status !== 200) {
        thunkAPI.dispatch(hideLoader());
      }
      thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({ message: "Error encountered!", type: "error" }),
      );
    }
  },
);

export const getBillingListByPetId = createAsyncThunk(
  "getBillingListByPetId",
  async ({ petId, data = { page: 1, itemSize: 5 } }, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).post(
        `/appointment/clinic/payments/pet/${petId}`,
        data,
      );
      if (res.status === 200 || res.status === 201) {
        thunkAPI.dispatch(hideLoader());
        return res.data;
      } else if (res.status !== 200) {
        thunkAPI.dispatch(hideLoader());
      }
      thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({ message: "Error encountered!", type: "error" }),
      );
    }
  },
);

export const deleteBillingPaymentById = createAsyncThunk(
  "deleteBillingPaymentById",
  async (id, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).delete(
        `/clinic/payments/${id}`,
      );
      if (res.status === 200 || res.status === 201) {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({
            message: "Payment discarded successfully",
            type: "success",
          }),
        );
        return true;
      }
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Payment discard failed!",
          type: "error",
        }),
      );
      return false;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Payment discard failed!",
          type: "error",
        }),
      );
    }
  },
);

export const getPetBillingByIdAll = createAsyncThunk(
  "getPetBillingByIdAll",
  async ({ petId, data = { itemSize: 50, page: 1 } }, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).post(
        `/appointment/clinic/payments/pet/${petId}`,
        data,
      );
      if (res.status === 200 || res.status === 201) {
        thunkAPI.dispatch(hideLoader());
        return res?.data?.data;
      } else if (res.status !== 200) {
        thunkAPI.dispatch(hideLoader());
      }
      thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({ message: "Error encountered!", type: "error" }),
      );
    }
  },
);

export const getPetBillingByIdAllWoLoader = createAsyncThunk(
  "getPetBillingByIdAllWoLoader",
  async ({ petId, data = { itemSize: 50, page: 1 } }, thunkAPI) => {
    try {
      // thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).post(
        `/appointment/clinic/payments/pet/${petId}`,
        data,
      );
      if (res.status === 200 || res.status === 201) {
        // thunkAPI.dispatch(hideLoader());
        return res?.data;
      } else if (res.status !== 200) {
        // thunkAPI.dispatch(hideLoader());
      }
      // thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      // thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({ message: "Error encountered!", type: "error" }),
      );
    }
  },
);

export const getPetBulkBillingByIdAllWoLoader = createAsyncThunk(
  "getPetBulkBillingByIdAllWoLoader",
  async ({ petId, data = { itemSize: 50, page: 1 } }, thunkAPI) => {
    try {
      // thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).post(
        `/appointment/clinic/payments/pet/${petId}`,
        data,
      );
      if (res.status === 200 || res.status === 201) {
        // thunkAPI.dispatch(hideLoader());
        return res?.data;
      } else if (res.status !== 200) {
        // thunkAPI.dispatch(hideLoader());
      }
      // thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      // thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({ message: "Error encountered!", type: "error" }),
      );
    }
  },
);

export const getVirAvailabilityByVetId = createAsyncThunk(
  "getVirAvailabilityByVetId",
  async (vetId, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).get(
        `/doctor/${vetId}/slot/days?type=virtual`,
      );
      if (res?.status === 200) {
        thunkAPI.dispatch(hideLoader());
        return res?.data?.data;
      }
      thunkAPI.dispatch(hideLoader());
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
    }
  },
);

export const getHomeAvailabilityByVetId = createAsyncThunk(
  "getHomeAvailabilityByVetId",
  async (vetId, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).get(
        `/doctor/${vetId}/slot/days?type=home`,
      );
      if (res?.status === 200) {
        thunkAPI.dispatch(hideLoader());
        return res?.data?.data;
      }
      thunkAPI.dispatch(hideLoader());
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
    }
  },
);

export const getPhyAvailabilityByVetId = createAsyncThunk(
  "getPhyAvailabilityByVetId",
  async (vetId, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).get(
        `/doctor/${vetId}/slot/days?type=physical`,
      );
      if (res?.status === 200) {
        thunkAPI.dispatch(hideLoader());
        return res?.data?.data;
      }
      thunkAPI.dispatch(hideLoader());
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
    }
  },
);

export const getAvailabilityByVetIdAndType = createAsyncThunk(
  "getAvailabilityByVetIdAndType",
  async ({ vetId, type }, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).get(
        `/doctor/${vetId}/slot/days?type=${type}`,
      );
      if (res?.status === 200) {
        thunkAPI.dispatch(hideLoader());
        return res?.data?.data;
      }
      thunkAPI.dispatch(hideLoader());
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
    }
  },
);

export const getAppointmentsByVetIdAndDate = createAsyncThunk(
  "getAppointmentsByVetIdAndDate",
  async ({ vetId, clinicId, date }, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).get(
        `/clinic/${clinicId}/doctor/${vetId}/day?type=appointment&date=${date}`,
      );
      if (res?.status === 200) {
        thunkAPI.dispatch(hideLoader());
        return res?.data?.data ? res?.data?.data : [];
      }
      thunkAPI.dispatch(hideLoader());
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
    }
  },
);

export const getClinicInpatients = createAsyncThunk(
  "getClinicInpatients",
  async (url = "", thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).get(
        `/getall/inpatient${url}`,
      );
      if (res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        return res?.data;
      } else if (res.status !== 200) {
        thunkAPI.dispatch(hideLoader());
      }
      thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
    }
  },
);

export const getClinicInpatientsWoLoader = createAsyncThunk(
  "getClinicInpatientsWoLoader",
  async (url = "", thunkAPI) => {
    try {
      // thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).get(
        `/getall/inpatient${url}`,
      );
      if (res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        return res?.data;
      } else if (res.status !== 200) {
        thunkAPI.dispatch(hideLoader());
      }
      thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
    }
  },
);

export const getInpatientById = createAsyncThunk(
  "getInpatientById",
  async ({ inpatientId, url = "" }, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).get(
        `/getall/inpatient/${inpatientId}${url}`,
      );
      if (res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        return res?.data?.data;
      } else if (res.status !== 200) {
        thunkAPI.dispatch(hideLoader());
      }
      thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
    }
  },
);

export const dischargePatientId = createAsyncThunk(
  "dischargePatientId",
  async (patientId, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).put(
        `/inpatient/${patientId}/discharge`,
      );

      if (res?.status === 200 || 201) {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({
            message: "Patient discharged successfully",
            type: "success",
          }),
        );
        return true;
      }
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Error encountered!",
          type: "error",
        }),
      );
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Error encountered!",
          type: "error",
        }),
      );
    }
  },
);

export const updateHospitalizationStatus = createAsyncThunk(
  "updateHospitalizationStatus",
  async ({ patientId, status = false }, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).put(
        `/inpatient/${patientId}/hospitalization?hospitalization=${status}`,
      );
      if (res?.status === 200 || 201) {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({
            message: "Changes updated successfully",
            type: "success",
          }),
        );
        return true;
      }
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Error encountered!",
          type: "error",
        }),
      );
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Error encountered!",
          type: "error",
        }),
      );
    }
  },
);

export const updateInpatientRedAlerts = createAsyncThunk(
  "updateInpatientRedAlerts",
  async (data, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).post(
        `/inpatient/summary-alert`,
        data,
      );
      if (res?.status === 200 || 201) {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({
            message: "Changes added successfully",
            type: "success",
          }),
        );
        return true;
      }
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Error encountered!",
          type: "error",
        }),
      );
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Error encountered!",
          type: "error",
        }),
      );
    }
  },
);

export const updateInpatientInstructions = createAsyncThunk(
  "updateInpatientInstructions",
  async ({ patientId, doctorId, text, summaryId = null }, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).post(
        `/inpatient/${patientId}/summary-note?doctorId=${doctorId}&text=${text}${
          summaryId ? `&summaryId=${summaryId}` : ""
        }`,
      );
      if (res?.status === 200 || 201) {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({
            message: "Changes added successfully",
            type: "success",
          }),
        );
        return true;
      }
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Error encountered!",
          type: "error",
        }),
      );
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Error encountered!",
          type: "error",
        }),
      );
    }
  },
);

export const updateInpatientNoteReviewed = createAsyncThunk(
  "updateInpatientNoteReviewed",
  async ({ noteId, reviewed = false }, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).put(
        `/clinic/inpatient-note/${noteId}?reviewed=${reviewed}`,
      );
      if (res?.status === 200 || 201) {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({
            message: "Reviewed successfully",
            type: "success",
          }),
        );
        return true;
      }
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Error encountered!",
          type: "error",
        }),
      );
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Error encountered!",
          type: "error",
        }),
      );
    }
  },
);

export const updateAppointmentAssignedUsers = createAsyncThunk(
  "updateAppointmentAssignedUsers",
  async ({ apntId, data }, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).post(
        `/clinic/update/appointment/${apntId}/assigned_users`,
        data,
      );
      if (res?.status === 200 || 201) {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({
            message: "Assigned users updated successfully",
            type: "success",
          }),
        );
        return true;
      }
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Error encountered!",
          type: "error",
        }),
      );
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Error encountered!",
          type: "error",
        }),
      );
    }
  },
);

export const updatePatientTaskStatusById = createAsyncThunk(
  "updatePatientTaskStatusById",
  async ({ taskId, url = "" }, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({
        contentType: true,
        auth: true,
      }).put(`/inpatient/task/${taskId}${url}`);
      if (res.status === 200 || res.status === 201) {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({
            message: "Task Updated successfully",
            type: "success",
          }),
        );
        return true;
      } else {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({ message: "Error encountered!", type: "error" }),
        );
      }
      thunkAPI.dispatch(hideLoader());
      return false;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({ message: "Error encountered!", type: "error" }),
      );
    }
  },
);

export const updatePatientTaskActiveStatusById = createAsyncThunk(
  "updatePatientTaskActiveStatusById",
  async ({ taskId, url = "" }, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({
        contentType: true,
        auth: true,
      }).put(`/inpatient/task/${taskId}/active${url}`);
      if (res.status === 200 || res.status === 201) {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({
            message: "Task Discontinued successfully",
            type: "success",
          }),
        );
        return true;
      }
      thunkAPI.dispatch(hideLoader());
      return false;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({ message: "Error encountered!", type: "error" }),
      );
    }
  },
);

export const deleteTasksByIds = createAsyncThunk(
  "deleteTasksByIds",
  async (ids, thunkAPI) => {
    try {
      // thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).put(
        "/inpatient/task",
        ids,
      );
      if (res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        // thunkAPI.dispatch(
        //   showSnackBar({
        //     message: "Task deleted successfully",
        //     type: "success",
        //   })
        // );
        return true;
      }
      thunkAPI.dispatch(hideLoader());
      // thunkAPI.dispatch(
      //   showSnackBar({
      //     message: "Error encountered!",
      //     type: "error",
      //   })
      // );
      return false;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Error encountered!",
          type: "error",
        }),
      );
    }
  },
);

export const getClinicAllergies = createAsyncThunk(
  "getClinicAllergies",
  async (url = "", thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).get(
        `/clinic/allergies${url}`,
      );
      if (res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        return res?.data?.data;
      }
      thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
    }
  },
);

export const getClinicAllergiesWoLoader = createAsyncThunk(
  "getClinicAllergiesWoLoader",
  async (url = "", thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).get(
        `/clinic/allergies${url}`,
      );
      if (res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        return res?.data?.data;
      }
      thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
    }
  },
);

export const getClinicInternalTags = createAsyncThunk(
  "getClinicInternalTags",
  async (url = "", thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).get(
        `/clinic/internaltags${url}`,
      );
      if (res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        return res?.data?.data;
      }
      thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
    }
  },
);

export const getClinicInternalTagsWoLoader = createAsyncThunk(
  "getClinicInternalTagsWoLoader",
  async (url = "", thunkAPI) => {
    try {
      // thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).get(
        `/clinic/internaltags${url}`,
      );
      if (res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        return res?.data?.data;
      }
      thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
    }
  },
);

export const getClinicUsers = createAsyncThunk(
  "getClinicUsers",
  async (url = "", thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).get(
        `/clinic/users${url}`,
      );
      if (res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        return res?.data?.data;
      }
      thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
    }
  },
);

export const getClinicNotification = createAsyncThunk(
  "getClinicNotification",
  async (_, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).get(
        `clinic/notifications`,
      );
      if (res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        return res?.data?.data;
      }
      thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
    }
  },
);

export const getClinicNotificationWoLoader = createAsyncThunk(
  "getClinicNotificationWoLoader",
  async (_, thunkAPI) => {
    try {
      // thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).get(
        `clinic/notifications`,
      );
      if (res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        return res?.data?.data;
      }
      thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
    }
  },
);

export const getLocations = createAsyncThunk(
  "getLocations",
  async (url = "", thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).get(
        `/location${url}`,
      );
      if (res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        return res?.data?.data;
      }
      thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
    }
  },
);

export const createLocation = createAsyncThunk(
  "createLocation",
  async (data, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).post(
        `/location`,
        data,
      );
      if (res?.status === 200) {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({
            message: "Location created successfully!",
            type: "success",
          }),
        );
        return res;
      }
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Error encountered!",
          type: "error",
        }),
      );
      return false;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Error encountered!",
          type: "error",
        }),
      );
    }
  },
);

export const updateLocationById = createAsyncThunk(
  "updateLocationById",
  async ({ locationId, data }, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).put(
        `/location/${locationId}`,
        data,
      );
      if (res?.status === 200 || res?.status === 201) {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({
            message: "Location updated successfully!",
            type: "success",
          }),
        );
        return true;
      }
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Error encountered!",
          type: "error",
        }),
      );
      return false;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Error encountered!",
          type: "error",
        }),
      );
    }
  },
);

export const deleteLocationById = createAsyncThunk(
  "deleteLocationById",
  async (id, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).delete(
        `/location/${id}`,
      );
      if (res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({
            message: "Location removed successfully",
            type: "success",
          }),
        );
        return true;
      }
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Error encountered!",
          type: "error",
        }),
      );
      return false;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Error encountered!",
          type: "error",
        }),
      );
    }
  },
);

export const getStockIssues = createAsyncThunk(
  "getStockIssues",
  async (url = "", thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).get(
        `/stock/issue${url}`,
      );
      if (res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        return res?.data;
      }
      thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
    }
  },
);

export const createStockIssue = createAsyncThunk(
  "createStockIssue",
  async (data, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).post(
        `/stock/issue`,
        data,
      );
      if (res?.status === 200) {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({
            message: "Stock Issue created successfully!",
            type: "success",
          }),
        );
        return true;
      }
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Error encountered!",
          type: "error",
        }),
      );
      return false;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Error encountered!",
          type: "error",
        }),
      );
    }
  },
);

export const updateStockIssues = createAsyncThunk(
  "updateStockIssues",
  async ({ issueId, data }, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).put(
        `/stock/issue/${issueId}`,
        data,
      );
      if (res?.status === 200 || res?.status === 201) {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({
            message: "Stock Issue updated successfully!",
            type: "success",
          }),
        );
        return true;
      }
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Error encountered!",
          type: "error",
        }),
      );
      return false;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Error encountered!",
          type: "error",
        }),
      );
    }
  },
);

export const deleteStockIssueById = createAsyncThunk(
  "deleteStockIssueById",
  async (id, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).delete(
        `/stock/issue/${id}`,
      );
      if (res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({
            message: "Stock Issue removed successfully",
            type: "success",
          }),
        );
        return true;
      }
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Error encountered!",
          type: "error",
        }),
      );
      return false;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Error encountered!",
          type: "error",
        }),
      );
    }
  },
);

export const updateStockIssueStatusById = createAsyncThunk(
  "updateStockIssueStatusById",
  async ({ id, status, data }, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).put(
        `/stock/issue/${id}/status?status=${status}`,
        data,
      );
      if (res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({
            message: "Status updated successfully",
            type: "success",
          }),
        );
        return true;
      }
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Error encountered!",
          type: "error",
        }),
      );
      return false;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Error encountered!",
          type: "error",
        }),
      );
    }
  },
);

export const getClinicForms = createAsyncThunk(
  "getClinicForms",
  async (url = "", thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).get(
        `/clinic/forms${url}`,
      );
      if (res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        return res?.data?.data;
      }
      thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
    }
  },
);

export const getClinicFormsWoLoader = createAsyncThunk(
  "getClinicFormsWoLoader",
  async (url = "", thunkAPI) => {
    try {
      // thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).get(
        `/clinic/forms${url}`,
      );
      if (res.status === 200) {
        // thunkAPI.dispatch(hideLoader());
        return res?.data?.data;
      }
      // thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      // thunkAPI.dispatch(hideLoader());
    }
  },
);

export const getFormsByAppointmentId = createAsyncThunk(
  "getFormsByAppointmentId",
  async (apntId, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).get(
        `/clinic/form/appointment/${apntId}`,
      );
      if (res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        return res?.data?.data;
      }
      thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
    }
  },
);

export const getFormsByAppointmentIdWoLoader = createAsyncThunk(
  "getFormsByAppointmentIdWoLoader",
  async (apntId, thunkAPI) => {
    try {
      // thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).get(
        `/clinic/form/appointment/${apntId}`,
      );
      if (res.status === 200) {
        // thunkAPI.dispatch(hideLoader());
        return res?.data?.data;
      }
      // thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      // thunkAPI.dispatch(hideLoader());
    }
  },
);

export const createClinicForm = createAsyncThunk(
  "createClinicForm",
  async (data, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).post(
        `/clinic/forms`,
        data,
      );
      if (res?.status === 200) {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({
            message: "Form added successfully!",
            type: "success",
          }),
        );
        return true;
      }
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Error encountered!",
          type: "error",
        }),
      );
      return false;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Error encountered!",
          type: "error",
        }),
      );
    }
  },
);

export const updateFromById = createAsyncThunk(
  "updateFromById",
  async ({ formId, data }, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).put(
        `/clinic/forms/${formId}`,
        data,
      );
      if (res?.status === 200 || res?.status === 201) {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({
            message: "Form updated successfully!",
            type: "success",
          }),
        );
        return true;
      }
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Error encountered!",
          type: "error",
        }),
      );
      return false;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Error encountered!",
          type: "error",
        }),
      );
    }
  },
);

export const deleteFromById = createAsyncThunk(
  "deleteFromById",
  async (id, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).delete(
        `/clinic/forms/${id}`,
      );
      if (res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({
            message: "Form removed successfully",
            type: "success",
          }),
        );
        return true;
      }
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Error encountered!",
          type: "error",
        }),
      );
      return false;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Error encountered!",
          type: "error",
        }),
      );
    }
  },
);

export const getVitalsByAppointmentId = createAsyncThunk(
  "getVitalsByAppointmentId",
  async (apntId, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).get(
        `/clinic/vitals/appointment/${apntId}`,
      );
      if (res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        return res?.data?.data;
      }
      thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
    }
  },
);

export const getVitalsByAppointmentIdWoLoader = createAsyncThunk(
  "getVitalsByAppointmentIdWoLoader",
  async (apntId, thunkAPI) => {
    try {
      // thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).get(
        `/clinic/vitals/appointment/${apntId}`,
      );
      if (res.status === 200) {
        // thunkAPI.dispatch(hideLoader());
        return res?.data?.data;
      }
      // thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      // thunkAPI.dispatch(hideLoader());
    }
  },
);

export const createVitalsByAppointmentId = createAsyncThunk(
  "createVitalsByAppointmentId",
  async ({ apntId, data }, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).post(
        `/clinic/pet/appointment/${apntId}/vitals`,
        data,
      );
      if (res?.status === 200) {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({
            message: "Vitals added successfully!",
            type: "success",
          }),
        );
        return true;
      }
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Error encountered!",
          type: "error",
        }),
      );
      return false;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Error encountered!",
          type: "error",
        }),
      );
    }
  },
);

export const createVitalsByAppointmentIdWoLoader = createAsyncThunk(
  "createVitalsByAppointmentIdWoLoader",
  async ({ apntId, data }, thunkAPI) => {
    try {
      // thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).post(
        `/clinic/pet/appointment/${apntId}/vitals`,
        data,
      );
      if (res?.status === 200) {
        // thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({
            message: "Vitals added successfully!",
            type: "success",
          }),
        );
        return true;
      }
      // thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Error encountered!",
          type: "error",
        }),
      );
      return false;
    } catch (err) {
      // thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Error encountered!",
          type: "error",
        }),
      );
    }
  },
);

export const deleteVitalsByIdWoLoader = createAsyncThunk(
  "deleteVitalsByIdWoLoader",
  async (vitalId, thunkAPI) => {
    try {
      // thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).delete(
        `/clinic/pet/vital/${vitalId}`,
      );
      if (res.status === 200 || res.status === 201) {
        // thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({
            message: "Vital removed successfully",
            type: "success",
          }),
        );
        return true;
      }
      // thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Error encountered!",
          type: "error",
        }),
      );
      return false;
    } catch (err) {
      // thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Error encountered!",
          type: "error",
        }),
      );
    }
  },
);

export const getBodyMapsByAppointmentId = createAsyncThunk(
  "getBodyMapsByAppointmentId",
  async (apntId, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).get(
        `/clinic/body/map/appointment/${apntId}`,
      );
      if (res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        return res?.data?.data;
      }
      thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
    }
  },
);

export const getBodyMapsByAppointmentIdWoLoader = createAsyncThunk(
  "getBodyMapsByAppointmentIdWoLoader",
  async (apntId, thunkAPI) => {
    try {
      // thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).get(
        `/clinic/body/map/appointment/${apntId}`,
      );
      if (res.status === 200) {
        // thunkAPI.dispatch(hideLoader());
        return res?.data?.data;
      }
      // thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      // thunkAPI.dispatch(hideLoader());
    }
  },
);

export const createBodyMapByAppointmentId = createAsyncThunk(
  "createBodyMapByAppointmentId",
  async ({ apntId, form }, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({
        contentType: true,
        auth: true,
        formData: true,
      }).post(`/clinic/pet/appointment/${apntId}/bodymap`, form);
      if (res?.status === 200) {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({
            message: "Body Map added successfully!",
            type: "success",
          }),
        );
        return true;
      }
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Error encountered!",
          type: "error",
        }),
      );
      return false;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Error encountered!",
          type: "error",
        }),
      );
    }
  },
);

export const createBodyMapByAppointmentIdWoLoader = createAsyncThunk(
  "createBodyMapByAppointmentIdWoLoader",
  async ({ apntId, form }, thunkAPI) => {
    try {
      // thunkAPI.dispatch(showLoader());
      const res = await api({
        contentType: true,
        auth: true,
        formData: true,
      }).post(`/clinic/pet/appointment/${apntId}/bodymap`, form);
      if (res?.status === 200) {
        // thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({
            message: "Body Map added successfully!",
            type: "success",
          }),
        );
        return true;
      }
      // thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Error encountered!",
          type: "error",
        }),
      );
      return false;
    } catch (err) {
      // thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Error encountered!",
          type: "error",
        }),
      );
    }
  },
);

export const deleteBodyMapById = createAsyncThunk(
  "deleteBodyMapById",
  async (id, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).delete(
        `/clinic/body/map/${id}`,
      );
      if (res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({
            message: "Item removed successfully",
            type: "success",
          }),
        );
        return true;
      }
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Error encountered!",
          type: "error",
        }),
      );
      return false;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Error encountered!",
          type: "error",
        }),
      );
    }
  },
);

export const deleteBodyMapByIdWoLoader = createAsyncThunk(
  "deleteBodyMapByIdWoLoader",
  async (id, thunkAPI) => {
    try {
      // thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).delete(
        `/clinic/body/map/${id}`,
      );
      if (res.status === 200) {
        // thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({
            message: "Item removed successfully",
            type: "success",
          }),
        );
        return true;
      }
      // thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Error encountered!",
          type: "error",
        }),
      );
      return false;
    } catch (err) {
      // thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Error encountered!",
          type: "error",
        }),
      );
    }
  },
);

export const assignFormByAppointmentId = createAsyncThunk(
  "assignFormByAppointmentId",
  async ({ apntId, formId }, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).post(
        `/clinic/pet/appointment/${apntId}/form/${formId}`,
      );
      if (res?.status === 200) {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({
            message: "Form added successfully!",
            type: "success",
          }),
        );
        return true;
      }
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Error encountered!",
          type: "error",
        }),
      );
      return false;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Error encountered!",
          type: "error",
        }),
      );
    }
  },
);

export const assignFormByAppointmentIdWoLoader = createAsyncThunk(
  "assignFormByAppointmentIdWoLoader",
  async ({ apntId, formId }, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).post(
        `/clinic/pet/appointment/${apntId}/form/${formId}`,
      );
      if (res?.status === 200) {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({
            message: "Form added successfully!",
            type: "success",
          }),
        );
        return true;
      }
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Error encountered!",
          type: "error",
        }),
      );
      return false;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Error encountered!",
          type: "error",
        }),
      );
    }
  },
);

export const updatePetFromById = createAsyncThunk(
  "updatePetFromById",
  async ({ formId, form }, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({
        contentType: true,
        auth: true,
        formData: true,
      }).put(`/clinic/pet/forms/${formId}?status=true`, form);
      if (res?.status === 200 || res?.status === 201) {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({
            message: "Form updated successfully!",
            type: "success",
          }),
        );
        return true;
      }
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Error encountered!",
          type: "error",
        }),
      );
      return false;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Error encountered!",
          type: "error",
        }),
      );
    }
  },
);

export const updatePetFromByIdWoLoader = createAsyncThunk(
  "updatePetFromByIdWoLoader",
  async ({ formId, form }, thunkAPI) => {
    try {
      // thunkAPI.dispatch(showLoader());
      const res = await api({
        contentType: true,
        auth: true,
        formData: true,
      }).put(`/clinic/pet/forms/${formId}?status=true`, form);
      if (res?.status === 200 || res?.status === 201) {
        // thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({
            message: "Form updated successfully!",
            type: "success",
          }),
        );
        return true;
      }
      // thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Error encountered!",
          type: "error",
        }),
      );
      return false;
    } catch (err) {
      // thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Error encountered!",
          type: "error",
        }),
      );
    }
  },
);

export const deletePetFromById = createAsyncThunk(
  "deletePetFromById",
  async (id, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).delete(
        `/clinic/pet/forms/${id}`,
      );
      if (res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({
            message: "Form removed successfully",
            type: "success",
          }),
        );
        return true;
      }
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Error encountered!",
          type: "error",
        }),
      );
      return false;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Error encountered!",
          type: "error",
        }),
      );
    }
  },
);

export const deletePetFromByIdWoLoader = createAsyncThunk(
  "deletePetFromByIdWoLoader",
  async (id, thunkAPI) => {
    try {
      // thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).delete(
        `/clinic/pet/forms/${id}`,
      );
      if (res.status === 200) {
        // thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({
            message: "Form removed successfully",
            type: "success",
          }),
        );
        return true;
      }
      // thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Error encountered!",
          type: "error",
        }),
      );
      return false;
    } catch (err) {
      // thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Error encountered!",
          type: "error",
        }),
      );
    }
  },
);

export const getFilesByAppointmentId = createAsyncThunk(
  "getFilesByAppointmentId",
  async (apntId, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).get(
        `/clinic/files/appointment/${apntId}`,
      );
      if (res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        return res?.data?.data;
      }
      thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
    }
  },
);

export const getFilesByAppointmentIdWoLoader = createAsyncThunk(
  "getFilesByAppointmentIdWoLoader",
  async (apntId, thunkAPI) => {
    try {
      // thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).get(
        `/clinic/files/appointment/${apntId}`,
      );
      if (res.status === 200) {
        // thunkAPI.dispatch(hideLoader());
        return res?.data?.data;
      }
      // thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      // thunkAPI.dispatch(hideLoader());
    }
  },
);

export const getAllDiscountCodes = createAsyncThunk(
  "getAllDiscountCodes",
  async (url = "", thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).get(
        `/getall/clinic/billings${url}`,
      );
      if (res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        return res?.data?.data;
      }
      thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
    }
  },
);

export const getClinicRoles = createAsyncThunk(
  "getClinicRoles",
  async (url = "", thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).get(
        `/getall/clinic/roles${url}`,
      );
      if (res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        return res?.data?.data;
      }
      thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
    }
  },
);

export const updateDiscountCodeById = createAsyncThunk(
  "updateDiscountCodeById",
  async ({ id, data }, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).put(
        `/update/clinic/billing/${id}`,
        data,
      );
      if (res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        return true;
      }
      thunkAPI.dispatch(hideLoader());
      return false;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
    }
  },
);

export const createFilesByAppointmentId = createAsyncThunk(
  "createClinicForm",
  async ({ apntId, form }, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({
        contentType: true,
        auth: true,
        formData: true,
      }).post(`/clinic/files/appointment/${apntId}`, form);
      if (res?.status === 200) {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({
            message: "File added successfully!",
            type: "success",
          }),
        );
        return true;
      }
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Error encountered!",
          type: "error",
        }),
      );
      return false;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Error encountered!",
          type: "error",
        }),
      );
    }
  },
);

export const createFilesByAppointmentIdWoLoader = createAsyncThunk(
  "createFilesByAppointmentIdWoLoader",
  async ({ apntId, form }, thunkAPI) => {
    try {
      // thunkAPI.dispatch(showLoader());
      const res = await api({
        contentType: true,
        auth: true,
        formData: true,
      }).post(`/clinic/files/appointment/${apntId}`, form);
      if (res?.status === 200) {
        // thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({
            message: "File added successfully!",
            type: "success",
          }),
        );
        return true;
      }
      // thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Error encountered!",
          type: "error",
        }),
      );
      return false;
    } catch (err) {
      // thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Error encountered!",
          type: "error",
        }),
      );
    }
  },
);

export const updateFilesByIdWoLoader = createAsyncThunk(
  "updateFilesByIdWoLoader",
  async ({ fileId, form }, thunkAPI) => {
    try {
      // thunkAPI.dispatch(showLoader());
      const res = await api({
        contentType: true,
        auth: true,
        formData: true,
      }).put(`/clinic/files/${fileId}`, form);
      if (res?.status === 200) {
        // thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({
            message: "File updated successfully!",
            type: "success",
          }),
        );
        return true;
      }
      // thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Error encountered!",
          type: "error",
        }),
      );
      return false;
    } catch (err) {
      // thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Error encountered!",
          type: "error",
        }),
      );
    }
  },
);

export const deleteFileById = createAsyncThunk(
  "deleteFileById",
  async (id, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).delete(
        `/clinic/files/${id}`,
      );
      if (res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({
            message: "File removed successfully",
            type: "success",
          }),
        );
        return true;
      }
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Error encountered!",
          type: "error",
        }),
      );
      return false;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Error encountered!",
          type: "error",
        }),
      );
    }
  },
);

export const deleteFileByIdWoLoader = createAsyncThunk(
  "deleteFileByIdWoLoader",
  async (id, thunkAPI) => {
    try {
      // thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).delete(
        `/clinic/files/${id}`,
      );
      if (res.status === 200) {
        // thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({
            message: "File removed successfully",
            type: "success",
          }),
        );
        return true;
      }
      // thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Error encountered!",
          type: "error",
        }),
      );
      return false;
    } catch (err) {
      // thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Error encountered!",
          type: "error",
        }),
      );
    }
  },
);

export const getBillingDashboardData = createAsyncThunk(
  "getBillingDashboardData",
  async (_, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).post(
        `/clinic/payments/dashboard-reports`,
      );
      if (res?.status === 200 || res?.status === 201) {
        thunkAPI.dispatch(hideLoader());
        return res?.data;
      }
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({ message: "Error encountered!", type: "error" }),
      );
      return false;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({ message: "Error encountered!", type: "error" }),
      );
    }
  },
);

export const getBillingCollectionReportData = createAsyncThunk(
  "getBillingCollectionReportData",
  async (data = {}, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).post(
        `/clinic/payment/collection/dashboard-reports`,
        data,
      );
      if (res?.status === 200 || res?.status === 201) {
        thunkAPI.dispatch(hideLoader());
        return res?.data;
      }
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({ message: "Error encountered!", type: "error" }),
      );
      return false;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({ message: "Error encountered!", type: "error" }),
      );
    }
  },
);

export const getBillingAllCollectionReportData = createAsyncThunk(
  "getBillingAllCollectionReportData",
  async (data = {}, thunkAPI) => {
    try {
      // thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).post(
        `/clinic/payment/collection/dashboard-reports`,
        data,
      );
      if (res?.status === 200 || res?.status === 201) {
        thunkAPI.dispatch(hideLoader());
        return res?.data;
      }
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({ message: "Error encountered!", type: "error" }),
      );
      return false;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({ message: "Error encountered!", type: "error" }),
      );
    }
  },
);

export const payAmountByPaymentId = createAsyncThunk(
  "payAmountByPaymentId",
  async ({ paymentId, data }, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).put(
        `/appointment/clinic/invoice/payments/${paymentId}`,
        data,
      );
      if (res?.status === 200 || res?.status === 201) {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({
            message: "Amount paid successfully",
            type: "success",
          }),
        );
        return true;
      }
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Failed to pay amount",
          type: "error",
        }),
      );
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
    }
  },
);

export const getDiagnosticTemplates = createAsyncThunk(
  "getDiagnosticTemplates",
  async (url = "", thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).get(
        `/clinic/diagnostic-template${url}`,
      );
      if (res?.status === 200) {
        thunkAPI.dispatch(hideLoader());
        return res?.data;
      }
      thunkAPI.dispatch(hideLoader());
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
    }
  },
);

export const getDiagnosticTemplatesWoLoader = createAsyncThunk(
  "getDiagnosticTemplatesWoLoader",
  async (url = "", thunkAPI) => {
    try {
      // thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).get(
        `/clinic/diagnostic-template${url}`,
      );
      if (res?.status === 200) {
        thunkAPI.dispatch(hideLoader());
        return res?.data;
      }
      thunkAPI.dispatch(hideLoader());
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
    }
  },
);

export const getDiagnosticTemplateByIdWoLoader = createAsyncThunk(
  "getDiagnosticTemplateByIdWoLoader",
  async (tempId, thunkAPI) => {
    try {
      // thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).get(
        `/clinic/diagnostic-template/${tempId}`,
      );
      if (res?.status === 200) {
        thunkAPI.dispatch(hideLoader());
        return res?.data?.data;
      }
      thunkAPI.dispatch(hideLoader());
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
    }
  },
);

export const createDiagnosticTemplate = createAsyncThunk(
  "createDiagnosticTemplate",
  async (data, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).post(
        `/clinic/diagnostic-template`,
        data,
      );
      if (res?.status === 200 || res?.status === 201) {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({
            message: "Template created successfully!",
            type: "success",
          }),
        );
        return true;
      }
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Template created failed",
          type: "error",
        }),
      );
      return false;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Template created failed",
          type: "error",
        }),
      );
    }
  },
);

export const updateDiagnosticTemplateById = createAsyncThunk(
  "updateDiagnosticTemplateById",
  async ({ tempId, data }, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).put(
        `/clinic/diagnostic-template/${tempId}`,
        data,
      );
      if (res?.status === 200 || res?.status === 201) {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({
            message: "Template updated successfully!",
            type: "success",
          }),
        );
        return true;
      }
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Template update failed",
          type: "error",
        }),
      );
      return false;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Template update failed",
          type: "error",
        }),
      );
    }
  },
);

export const getVitalsByIdsWoLoader = createAsyncThunk(
  "vital/getVitalsByIdsWoLoader",
  async (data, thunkAPI) => {
    try {
      // thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).post(
        `/get-all/clinic/vitals`,
        data,
      );
      if (res.status === 200 || res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        return res.data.data;
      }
      thunkAPI.dispatch(hideLoader());
      return [];
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({ message: "Failed to fetch vitals", type: "error" }),
      );
      return thunkAPI.rejectWithValue(err.response?.data || err.message);
    }
  },
);

export const clinicSlice = createSlice({
  name: "clinic",
  initialState: {
    branchesDataSharing: [],
    branches: [],
    branchesByClinicId: [],
    mainClinicDetails: {},
    userDetails: {},
    hospitals: {
      total: 0,
      hospitals: [],
    },
    doctors: {},
    appointments: { totalRecords: 0, appointments: [] },
    appointmentsByFilter: {},
    appointmentsForSuggestion: {},
    doctorAppointments: { totalRecords: 0, appointments: [] },
    petAppointments: { totalRecords: 0, appointments: [] },
    medicalOrders: { totalRecords: 0, orders: [] },
    settings: {},
    services: [],
    servicesList: {},
    roles: null,
    unittype: [],
    suppliers: [],
    consulation: null,
    paybill: null,
    products: [],
    filteredProducts: [],
    appointmentType: [],
    openingHours: [],
    details: {},
    holidays: [],
    termsAndConditions: [],
    dashboard: {},
    vet: {},
    vetUpcomingAppointments: [],
    vetAppointments: [],
    getSlot: [],
    payments: {},
    transactions: [],
    billDetails: {},
    billDetailsWoLoader: {},
    petBilling: {},
    petBillingList: {},
    petBulkBilling: {},
    petAllBilling: [],
    vetPhyAvailability: [],
    vetVirAvailability: [],
    vetHomeAvailability: [],
    vetAvailability: [],
    inpatients: [],
    inpatientTasks: [],
    inpatientDetails: {},
    vaccineList: [],
    dewormingList: [],
    fleaTreatmentList: [],
    diagnosisList: [],
    appointmentList: [],
    allergies: [],
    internaltags: [],
    users: [],
    hugePayments: {},
    paymentsByFilter: {},
    paymentsForSuggestion: {},
    notifications: [],
    clinicAppointments: [],
    paymentList: [],
    stockSales: [],
    clinicStocks: {},
    otherUsers: [],
    stocks: {},
    stocksByFilter: {},
    pendingStocks: {},
    stockAdjust: {},
    vetBookedApnts: [],
    locationList: [],
    serviceCategories: [],
    returnPaymentsNew: {},
    returnPayments: {},
    supplierReturns: {},
    vetTodayAppointments: [],
    todayAppointments: [],
    forms: [],
    petForms: [],
    petVitals: [],
    petBodyMaps: [],
    petFiles: [],
    petApntHistories: [],
    facilities: [],
    vitalGroups: [],
    coreVitals: [],
    vitalListById: [],
    discountCodes: [],
    stockIssues: {},
    clinicRoles: [],
    diagnosticDashboard: [],
    pharmacyDashboard: [],
    apiInProgress: {
      soapGeneration: false,
      clinicNotesPost: false,
      clinicNotesPut: false,
      consolidateSoap: false,
    },
    billDashboardData: {},
    inpatientAlerts: [],
    inpatientSummary: [],
    inpatientTaskList: [],
    billingCollectionReport: {},
    billingAllCollectionReport: {},
    diagnosticTemplates: { totalRecords: 0, list: [] },
    diagTemplateById: {},
    vitalsByIds: [],
    selectedClinicBranch: null,
  },

  reducers: {
    setConsultation: (state, action) => {
      state.consulation = action.payload;
    },
    setBillDetails: (state, action) => {
      state.billDetails = action.payload;
    },
    setSelectedClinicBranch: (state, action) => {
      state.selectedClinicBranch = action.payload;
    },
    setApiInProgress: (state, action) => {
      const { apiType, inProgress } = action.payload;
      if (state.apiInProgress.hasOwnProperty(apiType)) {
        state.apiInProgress[apiType] = inProgress;
      }
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getBranchesDataSharing.fulfilled, (state, action) => {
      state.branchesDataSharing = action.payload;
    });
    builder.addCase(
      getBranchesDataSharingWoLoader.fulfilled,
      (state, action) => {
        state.branchesDataSharing = action.payload;
      },
    );
    builder.addCase(getClinicBranches.fulfilled, (state, action) => {
      state.branches = action.payload;
    });
    builder.addCase(
      getClinicBranchesWithClinicIdWoLoader.fulfilled,
      (state, action) => {
        state.branchesByClinicId = action.payload;
      },
    );
    builder.addCase(getMainClinicDetailsWoLoader.fulfilled, (state, action) => {
      state.mainClinicDetails = action.payload;
    });
    builder.addCase(getClinicAppointemnts.fulfilled, (state, action) => {
      state.clinicAppointments = action.payload;
    });
    builder.addCase(getSlotById.fulfilled, (state, action) => {
      state.getSlot = action.payload;
    });

    builder.addCase(getClinics.fulfilled, (state, action) => {
      const payLoad = action.payload;
      state.hospitals = {
        totalRecords: payLoad?.length,
        hospitals: payLoad,
      };
    });
    builder.addCase(getAllClinicPayment.fulfilled, (state, action) => {
      state.payments = action.payload;
    });
    builder.addCase(
      getAllClinicPaymentOfHugeRecord.fulfilled,
      (state, action) => {
        state.hugePayments = action.payload;
      },
    );
    builder.addCase(getClinicPaymentsByFilter.fulfilled, (state, action) => {
      state.paymentsByFilter = action.payload;
    });
    builder.addCase(
      getClinicPaymentsForSuggestion.fulfilled,
      (state, action) => {
        state.paymentsForSuggestion = action.payload;
      },
    );
    builder.addCase(getNewReturnPayments.fulfilled, (state, action) => {
      state.returnPaymentsNew = action.payload;
    });
    builder.addCase(getReturnPayments.fulfilled, (state, action) => {
      state.returnPayments = action.payload;
    });
    builder.addCase(getAllClinicPaymentList.fulfilled, (state, action) => {
      state.paymentList = action.payload;
    });
    builder.addCase(getRecentTransactionsPayment.fulfilled, (state, action) => {
      state.transactions = action.payload;
    });
    builder.addCase(getDoctorsByClinicId.fulfilled, (state, action) => {
      state.doctors = action.payload;
    });
    builder.addCase(getAppointsmentsByClinic.fulfilled, (state, action) => {
      state.appointments = action?.payload?.data ?? [];
      if (action?.payload?.today) {
        state.todayAppointments = action?.payload?.data?.data ?? [];
      }
    });
    builder.addCase(
      getAppointsmentsByClinicWoLoader.fulfilled,
      (state, action) => {
        state.appointments = action?.payload?.data ?? [];
        if (action?.payload?.today) {
          state.todayAppointments = action?.payload?.data?.data ?? [];
        }
      },
    );
    builder.addCase(
      getAppointmentsByClinicAndFilter.fulfilled,
      (state, action) => {
        state.appointmentsByFilter = action?.payload ?? {};
      },
    );
    builder.addCase(
      getAppointmentsByClinicForSuggestion.fulfilled,
      (state, action) => {
        state.appointmentsForSuggestion = action?.payload ?? {};
      },
    );
    builder.addCase(getDoctorAppointsmentsById.fulfilled, (state, action) => {
      const payLoad = action.payload;
      state.doctorAppointments = {
        totalRecords: payLoad?.totalRecords,
        appointments: payLoad,
      };
    });
    builder.addCase(
      getVetAppointmentsByIdAndFilter.fulfilled,
      (state, action) => {
        state.vetAppointments = action?.payload?.data ?? [];
        if (action?.payload?.today) {
          state.vetTodayAppointments = action?.payload?.data ?? [];
        }
      },
    );
    builder.addCase(
      getVetAppointmentsByIdAndFilterWoLoader.fulfilled,
      (state, action) => {
        state.vetAppointments = action?.payload?.data ?? [];
        if (action?.payload?.today) {
          state.vetTodayAppointments = action?.payload?.data ?? [];
        }
      },
    );
    builder.addCase(getPetAppointsmentsById.fulfilled, (state, action) => {
      const payLoad = action.payload;
      state.petAppointments = {
        totalRecords: payLoad?.totalRecords,
        appointments: payLoad,
      };
    });
    builder.addCase(getMedicalOrdersByClinic.fulfilled, (state, action) => {
      const payLoad = action.payload;
      state.medicalOrders = {
        totalRecords: payLoad?.totalRecords,
        orders: payLoad?.neworders,
      };
    });
    builder.addCase(getClinicTerms.fulfilled, (state, action) => {
      state.termsAndConditions = action.payload;
    });
    builder.addCase(updateClinicOpeningHours.fulfilled, (state, action) => {
      state.settings = action.payload;
    });
    builder.addCase(getProductsByClinic.fulfilled, (state, action) => {
      state.products = action.payload;
    });
    builder.addCase(
      getProductsByClinicWithFilter.fulfilled,
      (state, action) => {
        state.filteredProducts = action.payload;
      },
    );
    builder.addCase(getStocksByClinic.fulfilled, (state, action) => {
      state.stocks = action.payload;
    });
    builder.addCase(getStocksByClinicByFilter.fulfilled, (state, action) => {
      state.stocksByFilter = action.payload;
    });
    builder.addCase(getPendingStocksByClinic.fulfilled, (state, action) => {
      state.pendingStocks = action.payload;
    });
    builder.addCase(updateClinicHolidays.fulfilled, (state, action) => {
      state.settings = action.payload;
    });
    builder.addCase(getServices.fulfilled, (state, action) => {
      state.services = action.payload;
    });
    builder.addCase(getServicesWoLoader.fulfilled, (state, action) => {
      state.services = action.payload;
    });
    builder.addCase(getServicesByFilter.fulfilled, (state, action) => {
      state.servicesList = action.payload;
    });
    builder.addCase(getRolesAndAccess.fulfilled, (state, action) => {
      state.roles = action.payload;
    });
    builder.addCase(getUnitType.fulfilled, (state, action) => {
      state.unittype = action.payload;
    });
    builder.addCase(getSupplier.fulfilled, (state, action) => {
      state.suppliers = action.payload;
    });
    builder.addCase(getSupplierReturns.fulfilled, (state, action) => {
      state.supplierReturns = action.payload;
    });
    builder.addCase(payBill.fulfilled, (state, action) => {
      state.paybill = action.payload;
    });
    builder.addCase(
      getClinicAppointmentTypesByUserId.fulfilled,
      (state, action) => {
        state.appointmentType = action.payload;
      },
    );
    builder.addCase(getClinicOpeningHours.fulfilled, (state, action) => {
      state.openingHours = action.payload;
    });
    builder.addCase(getClinicDetails.fulfilled, (state, action) => {
      state.details = action.payload;
    });
    builder.addCase(getClinicDetailsWoLoader.fulfilled, (state, action) => {
      state.details = action.payload;
    });
    builder.addCase(getClinicHolidays.fulfilled, (state, action) => {
      state.holidays = action.payload;
    });
    builder.addCase(getClinicDashboardData.fulfilled, (state, action) => {
      state.dashboard = action.payload;
    });
    builder.addCase(
      getClinicDashboardDataWoLoader.fulfilled,
      (state, action) => {
        state.dashboard = action.payload;
      },
    );
    builder.addCase(getVetDetailsById.fulfilled, (state, action) => {
      state.vet = action.payload;
    });
    builder.addCase(
      getVetUpcomingAppointmentsById.fulfilled,
      (state, action) => {
        state.vetUpcomingAppointments = action.payload;
      },
    );
    builder.addCase(getBillDetailsByPaymentId.fulfilled, (state, action) => {
      state.billDetails = action.payload;
    });
    builder.addCase(
      getBillDetailsByPaymentIdWoLoader.fulfilled,
      (state, action) => {
        state.billDetailsWoLoader = action.payload;
      },
    );
    builder.addCase(getPetBillingById.fulfilled, (state, action) => {
      state.petBilling = action.payload;
    });
    builder.addCase(getBillingListByPetId.fulfilled, (state, action) => {
      state.petBillingList = action.payload;
    });
    builder.addCase(getPetBillingByIdAllWoLoader.fulfilled, (state, action) => {
      state.petBilling = action.payload;
    });
    builder.addCase(
      getPetBulkBillingByIdAllWoLoader.fulfilled,
      (state, action) => {
        state.petBulkBilling = action.payload;
      },
    );
    builder.addCase(getPetBillingByIdAll.fulfilled, (state, action) => {
      state.petAllBilling = action.payload;
    });
    builder.addCase(getVirAvailabilityByVetId.fulfilled, (state, action) => {
      state.vetVirAvailability = action.payload;
    });
    builder.addCase(getHomeAvailabilityByVetId.fulfilled, (state, action) => {
      state.vetHomeAvailability = action.payload;
    });
    builder.addCase(getPhyAvailabilityByVetId.fulfilled, (state, action) => {
      state.vetPhyAvailability = action.payload;
    });
    builder.addCase(
      getAvailabilityByVetIdAndType.fulfilled,
      (state, action) => {
        state.vetAvailability = action.payload;
      },
    );
    builder.addCase(getClinicInpatients.fulfilled, (state, action) => {
      state.inpatients = action.payload;
    });
    builder.addCase(getClinicInpatientsWoLoader.fulfilled, (state, action) => {
      state.inpatients = action.payload;
    });
    builder.addCase(getInpatientTasks.fulfilled, (state, action) => {
      state.inpatientTasks = action.payload;
    });
    builder.addCase(getInpatientById.fulfilled, (state, action) => {
      state.inpatientDetails = action.payload;
    });
    builder.addCase(getVaccinationList.fulfilled, (state, action) => {
      state.vaccineList = action.payload;
    });
    builder.addCase(getDewormingList.fulfilled, (state, action) => {
      state.dewormingList = action.payload;
    });
    builder.addCase(getFleaTreatmentList.fulfilled, (state, action) => {
      state.fleaTreatmentList = action.payload;
    });
    builder.addCase(getDiagnosisList.fulfilled, (state, action) => {
      state.diagnosisList = action.payload;
    });
    builder.addCase(getDiagnosisListWoLoader.fulfilled, (state, action) => {
      state.diagnosisList = action.payload;
    });

    builder.addCase(getClinicAppointemntList.fulfilled, (state, action) => {
      state.appointmentList = action.payload;
    });
    builder.addCase(
      getClinicAppointemntListWithoutLoading.fulfilled,
      (state, action) => {
        state.appointmentList = action.payload;
      },
    );
    builder.addCase(getClinicAllergies.fulfilled, (state, action) => {
      state.allergies = action.payload;
    });
    builder.addCase(getClinicAllergiesWoLoader.fulfilled, (state, action) => {
      state.allergies = action.payload;
    });
    builder.addCase(getClinicInternalTags.fulfilled, (state, action) => {
      state.internaltags = action.payload;
    });
    builder.addCase(
      getClinicInternalTagsWoLoader.fulfilled,
      (state, action) => {
        state.internaltags = action.payload;
      },
    );
    builder.addCase(getClinicUsers.fulfilled, (state, action) => {
      state.users = action.payload;
    });
    builder.addCase(getClinicNotification.fulfilled, (state, action) => {
      state.notifications = action.payload;
    });
    builder.addCase(
      getClinicNotificationWoLoader.fulfilled,
      (state, action) => {
        state.notifications = action.payload;
      },
    );
    builder.addCase(getClinicStockSales.fulfilled, (state, action) => {
      state.stockSales = action.payload;
    });
    builder.addCase(getClinicStocks.fulfilled, (state, action) => {
      state.clinicStocks = action.payload;
    });
    builder.addCase(getClinicStocksWoLoader.fulfilled, (state, action) => {
      state.clinicStocks = action.payload;
    });
    builder.addCase(getClinicOtherUsers.fulfilled, (state, action) => {
      state.otherUsers = action.payload;
    });
    builder.addCase(getStockAdjust.fulfilled, (state, action) => {
      state.stockAdjust = action.payload;
    });
    builder.addCase(
      getAppointmentsByVetIdAndDate.fulfilled,
      (state, action) => {
        state.vetBookedApnts = action.payload;
      },
    );
    builder.addCase(getLocations.fulfilled, (state, action) => {
      state.locationList = action.payload;
    });
    builder.addCase(getServiceCategoryByType.fulfilled, (state, action) => {
      state.serviceCategories = action.payload;
    });
    builder.addCase(
      getServiceCategoryByTypeWOLoader.fulfilled,
      (state, action) => {
        state.serviceCategories = action.payload;
      },
    );
    builder.addCase(getUserDetailsById.fulfilled, (state, action) => {
      state.userDetails = action.payload;
    });
    builder.addCase(getClinicForms.fulfilled, (state, action) => {
      state.forms = action.payload;
    });
    builder.addCase(getClinicFormsWoLoader.fulfilled, (state, action) => {
      state.forms = action.payload;
    });

    builder.addCase(getFormsByAppointmentId.fulfilled, (state, action) => {
      state.petForms = action.payload;
    });
    builder.addCase(
      getFormsByAppointmentIdWoLoader.fulfilled,
      (state, action) => {
        state.petForms = action.payload;
      },
    );

    builder.addCase(getVitalsByAppointmentId.fulfilled, (state, action) => {
      state.petVitals = action.payload;
    });
    builder.addCase(
      getVitalsByAppointmentIdWoLoader.fulfilled,
      (state, action) => {
        state.petVitals = action.payload;
      },
    );

    builder.addCase(getBodyMapsByAppointmentId.fulfilled, (state, action) => {
      state.petBodyMaps = action.payload;
    });
    builder.addCase(
      getBodyMapsByAppointmentIdWoLoader.fulfilled,
      (state, action) => {
        state.petBodyMaps = action.payload;
      },
    );

    builder.addCase(getFilesByAppointmentId.fulfilled, (state, action) => {
      state.petFiles = action.payload;
    });
    builder.addCase(
      getFilesByAppointmentIdWoLoader.fulfilled,
      (state, action) => {
        state.petFiles = action.payload;
      },
    );
    builder.addCase(
      getAppointmentHistoriesByPetId.fulfilled,
      (state, action) => {
        state.petApntHistories = action.payload ?? [];
      },
    );
    builder.addCase(getClinicFacilities.fulfilled, (state, action) => {
      state.facilities = action.payload;
    });
    builder.addCase(getClinicFacilitiesWoLoader.fulfilled, (state, action) => {
      state.facilities = action.payload;
    });
    builder.addCase(getVitalGroupsWoLoader.fulfilled, (state, action) => {
      state.vitalGroups = action.payload;
    });
    builder.addCase(getCoreVitalsWoLoader.fulfilled, (state, action) => {
      state.coreVitals = action.payload;
    });
    builder.addCase(
      getVitalGroupsDetailsByIdWoLoader.fulfilled,
      (state, action) => {
        state.vitalListById = action.payload;
      },
    );
    builder.addCase(getAllDiscountCodes.fulfilled, (state, action) => {
      state.discountCodes = action.payload;
    });
    builder.addCase(getStockIssues.fulfilled, (state, action) => {
      const payLoad = action.payload;
      state.stockIssues = {
        data: payLoad?.data,
        totalRecords: payLoad?.totalRecords ?? 0,
      };
    });
    builder.addCase(getClinicRoles.fulfilled, (state, action) => {
      state.clinicRoles = action.payload;
    });
    builder.addCase(getDiagnosticDashboardData.fulfilled, (state, action) => {
      state.diagnosticDashboard = action.payload;
    });
    builder.addCase(getPharmacyDashboardData.fulfilled, (state, action) => {
      state.pharmacyDashboard = action.payload;
    });
    builder.addCase(getBillingDashboardData.fulfilled, (state, action) => {
      state.billDashboardData = action.payload;
    });
    builder.addCase(
      getInpatientAlertsByAppointmentId.fulfilled,
      (state, action) => {
        state.inpatientAlerts = action.payload;
      },
    );
    builder.addCase(
      getInpatientAlertsByAppointmentIdWoLoader.fulfilled,
      (state, action) => {
        state.inpatientAlerts = action.payload;
      },
    );
    builder.addCase(
      getInpatientSummaryByAppointmentId.fulfilled,
      (state, action) => {
        state.inpatientSummary = action.payload;
      },
    );
    builder.addCase(
      getInpatientSummaryByAppointmentIdWoLoader.fulfilled,
      (state, action) => {
        state.inpatientSummary = action.payload;
      },
    );
    builder.addCase(
      getInpatientTasksByAppointmentId.fulfilled,
      (state, action) => {
        state.inpatientTaskList = action.payload;
      },
    );
    builder.addCase(
      getBillingCollectionReportData.fulfilled,
      (state, action) => {
        state.billingCollectionReport = action.payload;
      },
    );
    builder.addCase(
      getBillingAllCollectionReportData.fulfilled,
      (state, action) => {
        state.billingAllCollectionReport = action.payload;
      },
    );
    builder.addCase(getDiagnosticTemplates.fulfilled, (state, action) => {
      state.diagnosticTemplates = {
        list: action.payload?.data,
        totalRecords: action.payload?.totalRecords ?? 0,
      };
    });
    builder.addCase(
      getDiagnosticTemplatesWoLoader.fulfilled,
      (state, action) => {
        state.diagnosticTemplates = {
          list: action.payload?.data,
          totalRecords: action.payload?.totalRecords ?? 0,
        };
      },
    );
    builder.addCase(
      getDiagnosticTemplateByIdWoLoader.fulfilled,
      (state, action) => {
        state.diagTemplateById = action.payload;
      },
    );
    builder.addCase(getVitalsByIdsWoLoader.fulfilled, (state, action) => {
      state.vitalsByIds = action.payload;
    });
  },
});

export const {
  setConsultation,
  setBillDetails,
  setApiInProgress,
  setSelectedClinicBranch,
} = clinicSlice.actions;

export default clinicSlice.reducer;
